var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-social-biography",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-social-biography:not(.animated) .animable {opacity: 0;}svg#freepik_stories-social-biography.animated #freepik--character-2--inject-112 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-social-biography.animated #freepik--character-1--inject-112 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-social-biography.animated #freepik--speech-bubble--inject-112 {animation: 1.5s Infinite  linear wind;animation-delay: 0s;}            @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-112",
    className: "animable",
    style: {
      transformOrigin: "250px 367.69px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-112",
    cx: 250,
    cy: 367.69,
    rx: 213.56,
    ry: 123.3,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "250px 367.69px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-112",
    className: "animable",
    style: {
      transformOrigin: "249.456px 391.534px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-112",
    cx: 382.75,
    cy: 407.46,
    rx: 67.82,
    ry: 39.16,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "382.75px 407.46px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-112",
    d: "M56.48,393.44c-10.85,6.26-10.85,16.42,0,22.68s28.44,6.26,39.29,0,10.85-16.42,0-22.68S67.33,387.17,56.48,393.44Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "76.125px 404.778px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-112",
    d: "M107.76,449.91l-7-4.05c-2.21-1.27-2.21-3.34,0-4.62L288,333.16a8.79,8.79,0,0,1,8,0l7,4c2.2,1.28,2.2,3.35,0,4.63L115.77,449.91A8.83,8.83,0,0,1,107.76,449.91Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "201.876px 391.534px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-112",
    className: "animable",
    style: {
      transformOrigin: "390.36px 138.46px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-112",
    className: "animable",
    style: {
      transformOrigin: "390.36px 138.46px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "452.11 223.94 448.89 225.86 328.57 156.07 331.78 154.15 452.11 223.94",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "390.34px 190.005px"
    },
    id: "elnv82641kvs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.78 154.15 448.89 222.08 448.89 122.72 331.78 54.81 331.78 154.15",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "390.335px 138.445px"
    },
    id: "elvxkf4iwv4pt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.25 85.31 390.25 188.46 384.18 184.95 384.18 81.81 390.25 85.31",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "387.215px 135.135px"
    },
    id: "eljqic4krf9q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.28 83.55 390.25 85.31 390.25 188.46 393.28 186.7 393.28 83.55",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "391.765px 136.005px"
    },
    id: "elmfzongua2ep",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.49,159.57,455,236.38V119.21L322.49,42.41Zm6.08-106.65,120.32,69.79V225.86L328.57,156.07Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "388.745px 139.395px"
    },
    id: "elpnoqpjcxrl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.57 156.07 331.78 154.15 331.78 54.81 328.57 52.92 328.57 156.07",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "330.175px 104.495px"
    },
    id: "ellmtzkvogv48",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.49 42.41 325.76 40.54 458.23 117.34 454.96 119.21 322.49 42.41",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "390.36px 79.875px"
    },
    id: "elkmx9atvsadh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.23 117.34 454.96 119.21 454.96 236.38 458.23 234.51 458.23 117.34",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "456.595px 176.86px"
    },
    id: "el4xaz7b1u7m5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.25 88.81 384.19 85.31 384.19 88.82 390.25 92.32 390.25 88.81",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "387.22px 88.815px"
    },
    id: "elwxojm73hx97",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el23kf0j5m8ka"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "390.25 92.32 393.28 90.56 390.25 88.81 390.25 92.32",
    style: {
      opacity: 0.15,
      transformOrigin: "391.765px 90.565px"
    },
    className: "animable",
    id: "eloaxbypnzj0g"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-112",
    className: "animable",
    style: {
      transformOrigin: "97.045px 147.62px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pictures--inject-112",
    className: "animable",
    style: {
      transformOrigin: "97.045px 77.85px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-112",
    className: "animable",
    style: {
      transformOrigin: "125.695px 61.31px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-112",
    className: "animable",
    style: {
      transformOrigin: "125.695px 61.31px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "107.28 89.45 108.99 90.47 144.14 70.18 142.43 69.15 107.28 89.45",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "125.71px 79.81px"
    },
    id: "eloxhrcwefc9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.43 69.15 108.99 88.45 109 53.44 142.43 34.15 142.43 69.15",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "125.71px 61.3px"
    },
    id: "el6hv9ysgszyb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.37,27.55l-41.61,24V96.07l41.61-24Zm-3.23,42.63L109,90.47v-37l35.14-20.29Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "126.565px 61.81px"
    },
    id: "el9tlf8b3kdg9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.14 70.18 142.43 69.15 142.43 34.15 144.14 33.15 144.14 70.18",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "143.285px 51.665px"
    },
    id: "eld25ch0frs89",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.37 27.55 145.63 26.55 104.02 50.58 105.76 51.58 147.37 27.55",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "125.695px 39.065px"
    },
    id: "elv8u75x8p5f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.02 50.58 105.76 51.58 105.76 96.07 104.02 95.07 104.02 50.58",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "104.89px 73.325px"
    },
    id: "elzjwz6ryk49",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Land--inject-112",
    className: "animable",
    style: {
      transformOrigin: "125.71px 67.13px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "141.12 68.11 110.3 85.9 110.3 77.01 118.01 59.21 122.81 63.66 121.08 71.12 131.72 48.36 141.12 59.21 141.12 68.11",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "125.71px 67.13px"
    },
    id: "elcl6jq3wq0p8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.52,50.62a5,5,0,0,0-2.28,4c0,1.45,1,2,2.28,1.31a5,5,0,0,0,2.28-4C124.8,50.48,123.78,49.89,122.52,50.62Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "122.52px 53.2662px"
    },
    id: "el17pm8akxnqa",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-112",
    className: "animable",
    style: {
      transformOrigin: "68.395px 94.395px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-112",
    className: "animable",
    style: {
      transformOrigin: "68.395px 94.395px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "49.97 122.53 51.69 123.55 86.83 103.26 85.12 102.24 49.97 122.53",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "68.4px 112.895px"
    },
    id: "elo61zzbc0kjd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.12 102.24 51.69 121.54 51.69 86.52 85.12 67.24 85.12 102.24",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "68.405px 94.39px"
    },
    id: "elrg9vgp2rl5j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.07,60.63l-41.62,24v44.49l41.62-24Zm-3.24,42.63L51.69,123.55v-37L86.83,66.23Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "69.26px 94.875px"
    },
    id: "el2p1querbnuf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.83 103.26 85.12 102.24 85.12 67.24 86.83 66.23 86.83 103.26",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "85.975px 84.745px"
    },
    id: "elnqnj4xlwdqj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.07 60.63 88.33 59.64 46.72 83.66 48.45 84.66 90.07 60.63",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "68.395px 72.15px"
    },
    id: "elzud9tm0k81",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.72 83.66 48.45 84.66 48.45 129.15 46.72 128.15 46.72 83.66",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "47.585px 106.405px"
    },
    id: "elkto4d5vrv7r",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-112",
    className: "animable",
    style: {
      transformOrigin: "68.405px 100.215px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "83.82 101.19 52.99 118.99 52.99 110.09 60.7 92.29 65.5 96.74 63.77 104.2 74.42 81.44 83.82 92.29 83.82 101.19",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "68.405px 100.215px"
    },
    id: "elrby0e3p8vve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.21,83.7a5,5,0,0,0-2.28,4c0,1.45,1,2,2.28,1.31A5,5,0,0,0,67.49,85C67.49,83.56,66.47,83,65.21,83.7Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "65.21px 86.3527px"
    },
    id: "el0m2gisht87uc",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-112",
    className: "animable",
    style: {
      transformOrigin: "68.395px 198.04px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-112",
    className: "animable",
    style: {
      transformOrigin: "68.395px 198.04px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "49.96 262.05 51.67 263.06 86.7 242.84 84.99 241.82 49.96 262.05",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "68.33px 252.44px"
    },
    id: "elba91qvgamzi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.99 241.82 51.67 261.06 51.81 154.19 85.14 134.96 84.99 241.82",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "68.405px 198.01px"
    },
    id: "elf8hrzqu3b8v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.07,128.38l-41.48,24-.14,116.31L89.92,244.7ZM86.7,242.84l-35,20.22.14-108.87,35-20.23Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "69.26px 198.535px"
    },
    id: "elyrs74j46hsp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.7 242.84 84.99 241.82 85.14 134.96 86.84 133.96 86.7 242.84",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "85.915px 188.4px"
    },
    id: "elaybvrrqpl2c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.07 128.38 88.33 127.39 46.86 151.33 48.59 152.33 90.07 128.38",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "68.465px 139.86px"
    },
    id: "eljhnauslqtuo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.86 151.33 48.59 152.33 48.45 268.64 46.72 267.65 46.86 151.33",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "47.655px 209.985px"
    },
    id: "elxw4hbzt0q6b",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-112",
    className: "animable",
    style: {
      transformOrigin: "68.405px 198.51px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "82.49 239.82 54.17 256.18 54.31 157.2 82.64 140.84 82.49 239.82",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "68.405px 198.51px"
    },
    id: "elku2q6ztpai",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-112",
    className: "animable",
    style: {
      transformOrigin: "68.405px 198.51px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "82.49 239.82 54.17 256.18 54.31 157.2 82.64 140.84 82.49 239.82",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "68.405px 198.51px"
    },
    id: "eljem5yz0env",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.17,228.71a26.09,26.09,0,0,0,4,0,51.29,51.29,0,0,0,13.79-3c3.43-1.27,6.86-2.91,10.48-3v17.16L78.66,242a13,13,0,0,0-5.26-2.92c-5.46-1.44-11.05,1.31-16.66,1.95a22,22,0,0,1-2.57.13Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "68.305px 232.355px"
    },
    id: "eljaib3knt6sj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.31,197.64c6.34-1.87,12.84-3.43,17.36-8.08,3.65-3.75,5.37-8.94,6.57-14s2-10.34,4.32-15a1,1,0,0,0,.08-.14v37.88c-.36.53-.71,1.06-1.09,1.58-4.16,5.63-10.29,10.34-17.29,10.71-3.29.17-6.69-.6-10-.59Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "68.45px 185.517px"
    },
    id: "elylor1sfjzbi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.31,172.74a19.3,19.3,0,0,0,6.28-17.57c-.09-.47-.2-.94-.32-1.41l10.9-6.29c0,.72-.08,1.43-.1,2.15-.12,4.16,0,8.37-.89,12.43a24.41,24.41,0,0,1-12.42,16,22.64,22.64,0,0,1-3.45,1.44Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "62.74px 163.48px"
    },
    id: "elgmvz0oti3hj",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-2--inject-112",
    className: "animable",
    style: {
      transformOrigin: "440.94px 343.309px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-112",
    className: "animable",
    style: {
      transformOrigin: "440.94px 343.309px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.19,320.37c-2.73,4.79-8.76,11.42-13,18.34-6.09,10-10.16,24-8.66,47.76l-3.19-1.84-7.84-4.53c-2.2-12.53-2.09-27.4,1.24-46.51,3.08-17.64,14-34.54,24.4-35.59C453.86,297,458,308.41,451.19,320.37Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "435.782px 342.204px"
    },
    id: "elcgp7nb4q808",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.85,379.6a.64.64,0,0,0,.38-.66c-4.08-32.65,9.37-62.76,23-73.65a.62.62,0,0,0,.1-.88.61.61,0,0,0-.87-.1C431.59,315.38,417.86,346,422,379.1a.62.62,0,0,0,.69.54Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "433.86px 341.908px"
    },
    id: "elvsqpgmi6hao",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.32,342.2c-1.86,6.15-13.73,12.61-21.33,22.85-6.86,9.26-9.85,18.65-9.6,23.63h0l-3.83-2.21-3.19-1.84c-1.74-23.16,6.78-36.66,14.16-45.73,2.18-2.67,8.16-6.39,10.57-7.16C461.8,328.33,466.57,334.81,464.32,342.2Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "445.503px 359.743px"
    },
    id: "elfqvnsgepu5i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,384.1a.63.63,0,0,0,.4-.55c1.46-26.49,17.23-40.32,25.37-43.93a.63.63,0,0,0-.51-1.15c-9,4-24.62,18-26.11,45a.62.62,0,0,0,.59.65A.57.57,0,0,0,430,384.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "442.631px 361.278px"
    },
    id: "el8t9k3giqnrd",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-1--inject-112",
    className: "animable",
    style: {
      transformOrigin: "77.415px 346.438px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-112",
    className: "animable",
    style: {
      transformOrigin: "77.415px 346.438px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-112",
    className: "animable",
    style: {
      transformOrigin: "76.1252px 379.974px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-112",
    className: "animable",
    style: {
      transformOrigin: "76.1252px 379.974px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.85,407c-8.71-9-13.82-45.55-5.33-52.67H97.73c8.49,7.12,3.38,43.67-5.32,52.66l-.24.25-.3.29c-.24.24-.51.48-.79.71l-.2.17c-.22.17-.43.34-.66.5s-.75.51-1.13.73c-7.16,4.18-18.77,4.18-25.93,0h0a13,13,0,0,1-1.14-.74l-.61-.46-.26-.21c-.27-.22-.52-.45-.76-.68l-.34-.34Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "76.1252px 383.553px"
    },
    id: "elmu0zrrbp6n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,351.48c9.86,5.76,9.86,15.09,0,20.85s-25.85,5.76-35.71,0-9.86-15.09,0-20.84S84.12,345.73,94,351.48Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "76.145px 361.911px"
    },
    id: "el04mtw92jfw6l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.24,354.25c7.24,4.23,7.24,11.08,0,15.31s-19,4.23-26.22,0-7.24-11.08,0-15.31S82,350,89.24,354.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "76.1337px 361.901px"
    },
    id: "el92jiaimln1f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,361.52c7.24-4.23,19-4.23,26.22,0a12,12,0,0,1,4.33,4,12,12,0,0,1-4.33,4c-7.25,4.23-19,4.23-26.22,0a11.92,11.92,0,0,1-4.34-4A11.92,11.92,0,0,1,63,361.52Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "76.105px 365.52px"
    },
    id: "el9otz3od2cnm",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-112",
    className: "animable",
    style: {
      transformOrigin: "77.415px 323.952px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.63,296,73,307.4,59.1,301a38.38,38.38,0,0,0,2.42,13.17,85.49,85.49,0,0,1,10.83,7.68l-10.67-4.21s-.73,7,2.2,17.75c.76,2.81,3.92,8.17,5.91,12.18a46,46,0,0,0,3.1,5.35c.06.11.14.21.21.32,2.44-1.39,5-2.75,7.6-4.06,1.72-3.6,4-12.51,4.76-19.8,3.07-27.92-18-43.92-35-49.28A50.61,50.61,0,0,1,58.63,296Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "68.1103px 316.67px"
    },
    id: "eli5mjq82th8g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elr2c1ezyin9k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.63,296,73,307.4,59.1,301a38.38,38.38,0,0,0,2.42,13.17,85.49,85.49,0,0,1,10.83,7.68l-10.67-4.21s-.73,7,2.2,17.75c.76,2.81,3.92,8.17,5.91,12.18a46,46,0,0,0,3.1,5.35c.06.11.14.21.21.32,2.44-1.39,5-2.75,7.6-4.06,1.72-3.6,4-12.51,4.76-19.8,3.07-27.92-18-43.92-35-49.28A50.61,50.61,0,0,1,58.63,296Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "68.1103px 316.67px"
    },
    className: "animable",
    id: "el6qu8m3b8ecm"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.66,297.16c2.93,2.95,4.65,6.84,6,10.72A56.74,56.74,0,0,1,79.18,320a52.3,52.3,0,0,1-3,24.24h0a.41.41,0,0,0,.76.29h0a52.88,52.88,0,0,0,2.69-24.58,56.92,56.92,0,0,0-2.76-12.1C75.43,303.94,73.64,300.06,70.66,297.16Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "75.3579px 320.953px"
    },
    id: "elb5r09dy79lg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.9,310.63l0,0a214.89,214.89,0,0,0-15,21.12l-14.59,2.35L102,336l-5.78,9.16-14.36,3L93.08,350S90,360.9,81.94,365.46c-4.43,2.52-6.6,2.91-7.93,1.64-.93-.88-1.15-6.13-1.92-10.82s-.84-12.31,3.58-21.5a28.66,28.66,0,0,1,4.6-6.76C90.89,316.19,111,310.48,120.9,310.63Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "96.2942px 339.216px"
    },
    id: "eljjjbzg1pi1i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ele26r8llnuwq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.9,310.63l0,0a214.89,214.89,0,0,0-15,21.12l-14.59,2.35L102,336l-5.78,9.16-14.36,3L93.08,350S90,360.9,81.94,365.46c-4.43,2.52-6.6,2.91-7.93,1.64-.93-.88-1.15-6.13-1.92-10.82s-.84-12.31,3.58-21.5a28.66,28.66,0,0,1,4.6-6.76C90.89,316.19,111,310.48,120.9,310.63Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "96.2942px 339.216px"
    },
    className: "animable",
    id: "el8iarvjent2l"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.63,315.4a59.66,59.66,0,0,0-20.31,14,39.91,39.91,0,0,0-6.95,10.32,38,38,0,0,0-3.18,12,0,0,0,0,0,0,.05,0,0,0,0,0,0,0,49.2,49.2,0,0,1,3.83-11.66,45.13,45.13,0,0,1,6.7-10.23,60.75,60.75,0,0,1,19.86-14.38,0,0,0,0,0,0-.06S105.65,315.4,105.63,315.4Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "90.4118px 333.585px"
    },
    id: "el86run6oghjp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.93,316.65h0a32.37,32.37,0,0,1,3.67.17,58.91,58.91,0,0,1,14,3.42c1.68.63,3.37,1.34,5,2.13.83.39,1.65.81,2.46,1.25a40.28,40.28,0,0,1,10.76,8.14A25.42,25.42,0,0,1,73.6,337c.13.25.27.48.39.73h0c.32.64.6,1.27.86,1.89A35,35,0,0,1,78,356.88c-.15,4.19-1.57,9-2.39,9.76a1.54,1.54,0,0,1-.36.27c-1.2.76-3.09.32-6.65-1.67-7.11-4-9.9-14.05-9.9-14.05L55.91,347l-5.16-8,9.49-1.73-12.89-2A190.14,190.14,0,0,0,34,316.67l0,0Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "56.0114px 341.954px"
    },
    id: "el215ksubmbur",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eln9g6mxtfggk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.93,316.65h0a32.37,32.37,0,0,1,3.67.17,58.91,58.91,0,0,1,14,3.42c1.68.63,3.37,1.34,5,2.13.83.39,1.65.81,2.46,1.25a40.28,40.28,0,0,1,10.76,8.14A25.42,25.42,0,0,1,73.6,337c.13.25.27.48.39.73h0c.32.64.6,1.27.86,1.89A35,35,0,0,1,78,356.88c-.15,4.19-1.57,9-2.39,9.76a1.54,1.54,0,0,1-.36.27c-1.2.76-3.09.32-6.65-1.67-7.11-4-9.9-14.05-9.9-14.05L55.91,347l-5.16-8,9.49-1.73-12.89-2A190.14,190.14,0,0,0,34,316.67l0,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "56.0114px 341.954px"
    },
    className: "animable",
    id: "el6zd1umul7vv"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eli70j34isgas"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6,316.82a58.91,58.91,0,0,1,14,3.42c1.68.63,3.37,1.34,5,2.13.83.39,1.65.81,2.46,1.25a40.28,40.28,0,0,1,10.76,8.14A25.42,25.42,0,0,1,73.6,337c.13.25.27.48.39.73h0c.32.64.6,1.27.86,1.89A35,35,0,0,1,78,356.88c-.15,4.19-1.57,9-2.39,9.76a1.54,1.54,0,0,1-.36.27,2.1,2.1,0,0,1-.78.29c.87-6.49-2.32-23-7.16-29.74-5-7-17-17.26-33.38-20.79h0A29.59,29.59,0,0,1,37.6,316.82Z",
    style: {
      fill: "#90CAF9",
      opacity: 0.4,
      transformOrigin: "56.0114px 341.932px"
    },
    className: "animable",
    id: "el2kwq8dc1s28"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.53,367.2a55.4,55.4,0,0,0-.94-14.36,46.39,46.39,0,0,0-4.76-13.62,40.35,40.35,0,0,0-9.65-10.77A54,54,0,0,0,46.81,321a0,0,0,0,0-.05,0,0,0,0,0,0,0,.06,69.74,69.74,0,0,1,11.89,8,50.08,50.08,0,0,1,5.23,4.86,31.39,31.39,0,0,1,4.37,5.6,45.92,45.92,0,0,1,4.93,13.38,55.66,55.66,0,0,1,1.25,14.28s0,0,0,0S74.52,367.22,74.53,367.2Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "60.7033px 344.103px"
    },
    id: "el0xvrcqgfo3nk",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-112",
    className: "animable",
    style: {
      transformOrigin: "201.965px 238.081px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-112",
    className: "animable",
    style: {
      transformOrigin: "201.965px 238.081px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-112",
    className: "animable",
    style: {
      transformOrigin: "201.965px 238.081px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.58,33.93,107.89,138.13a7.44,7.44,0,0,0-3.38,5.85V436a7.43,7.43,0,0,0,3.38,5.84l.69.39a7.51,7.51,0,0,0,6.77,0L296,337.9a7.45,7.45,0,0,0,3.38-5.85V40.15A7.4,7.4,0,0,0,296,34.31l-.68-.39A7.51,7.51,0,0,0,288.58,33.93Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "201.945px 238.081px"
    },
    id: "elc1ftxof7izi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.55,441.6c-1.29,0-2.07-1.06-2.07-2.83V149.71a8.81,8.81,0,0,1,4.39-7.61L295,39.23a2.55,2.55,0,0,1,1.3-.36,2.62,2.62,0,0,1,2.61,2.61V332.29c0,2.33-1.36,4.15-4.42,5.91L116.38,441A3.76,3.76,0,0,1,114.55,441.6Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "205.695px 240.235px"
    },
    id: "elljzzuxj3k5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.3,39.39a2.09,2.09,0,0,1,2.09,2.09V332.29c0,2.13-1.28,3.81-4.15,5.46L116.12,440.58a3.18,3.18,0,0,1-1.57.5c-1.4,0-1.55-1.61-1.55-2.31V149.71a8.29,8.29,0,0,1,4.13-7.16L295.26,39.67a2.06,2.06,0,0,1,1-.28m0-1a3.07,3.07,0,0,0-1.55.42L116.62,141.66a9.29,9.29,0,0,0-4.65,8.05V438.77c0,2.12,1,3.34,2.58,3.34a4.28,4.28,0,0,0,2.09-.64L294.75,338.64c2.59-1.48,4.67-3.38,4.67-6.35V41.48a3.12,3.12,0,0,0-3.12-3.12Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "205.695px 240.235px"
    },
    id: "elfrl9esdjtom",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.16,145.16a9.27,9.27,0,0,0-1.19,4.55v9.16l-7.46-4.31V144a6.76,6.76,0,0,1,1-3.26Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "108.835px 149.805px"
    },
    id: "el2elqzhit8jm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt7kpgc4lut"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.16,145.16a9.27,9.27,0,0,0-1.19,4.55v9.16l-7.46-4.31V144a6.76,6.76,0,0,1,1-3.26Z",
    style: {
      opacity: 0.25,
      transformOrigin: "108.835px 149.805px"
    },
    className: "animable",
    id: "elvzsuyz67tt"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112,158.86,299.42,50.64V41.48a3.11,3.11,0,0,0-4.67-2.7L116.62,141.66a9.29,9.29,0,0,0-4.65,8.05Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "205.695px 98.6102px"
    },
    id: "elhu9b4sbksjw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.42,40.15v1.33a3.12,3.12,0,0,0-4.68-2.7L116.61,141.66a9,9,0,0,0-3.39,3.4.19.19,0,0,0,0,.1l-7.71-4.45a7,7,0,0,1,2.43-2.58L288.58,33.93a7.52,7.52,0,0,1,6.76,0l.69.4A7.43,7.43,0,0,1,299.42,40.15Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "202.465px 89.1438px"
    },
    id: "elc2r19l8yafc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el04tt3ai5m4pg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.42,40.15v1.33a3.12,3.12,0,0,0-4.68-2.7L116.61,141.66a9,9,0,0,0-3.39,3.4.19.19,0,0,0,0,.1l-7.71-4.45a7,7,0,0,1,2.43-2.58L288.58,33.93a7.52,7.52,0,0,1,6.76,0l.69.4A7.43,7.43,0,0,1,299.42,40.15Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.25,
      transformOrigin: "202.465px 89.1438px"
    },
    className: "animable",
    id: "elnxk218id1xo"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274,55.65c1.16-.67,2.09-.13,2.09,1.2A4.61,4.61,0,0,1,274,60.47c-1.15.67-2.09.13-2.09-1.21A4.61,4.61,0,0,1,274,55.65Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "274px 58.0599px"
    },
    id: "el4f9i243x8vc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.39,50.82c1.15-.66,2.09-.12,2.09,1.21a4.64,4.64,0,0,1-2.09,3.62c-1.15.66-2.09.12-2.09-1.21A4.64,4.64,0,0,1,282.39,50.82Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "282.39px 53.235px"
    },
    id: "el7shgmhvzo8k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.75,46c1.15-.67,2.08-.13,2.08,1.2a4.6,4.6,0,0,1-2.08,3.62c-1.16.67-2.09.13-2.09-1.2A4.58,4.58,0,0,1,290.75,46Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "290.745px 48.41px"
    },
    id: "elqs10v5gp7gi",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Image--inject-112",
    className: "animable",
    style: {
      transformOrigin: "205.695px 160.46px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292.04 158.38 119.35 258.08 119.35 162.54 292.04 62.84 292.04 158.38",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "205.695px 160.46px"
    },
    id: "eljofbj0bak4k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.6,221.33l.36-.76c.39-.82,1.09-1.26,1.52-.95h0c.42.3,1.1-.11,1.5-.91l6.38-12.87c.38-.77,1-1.19,1.46-.94l5.36,3.21c.27.17.66,0,1-.3l1.28-1.28c.33-.34.7-.47,1-.33l3.13,1.55c.38.18.92-.13,1.3-.75l2.43-3.94c.39-.64.95-.95,1.33-.73l8.06,4.52c.39.23,1-.12,1.37-.8l6.18-10.85c.43-.76,1.1-1.09,1.48-.73l4.09,3.82c.33.3.88.11,1.31-.47l1.56-2.08c.36-.49.81-.71,1.14-.57l21.78,8.9-75.26,43.45V222.36A2.47,2.47,0,0,1,119.6,221.33Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "156.99px 220.922px"
    },
    id: "el0320pig17x8v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbd3ukp1ag5a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.6,221.33l.36-.76c.39-.82,1.09-1.26,1.52-.95h0c.42.3,1.1-.11,1.5-.91l6.38-12.87c.38-.77,1-1.19,1.46-.94l5.36,3.21c.27.17.66,0,1-.3l1.28-1.28c.33-.34.7-.47,1-.33l3.13,1.55c.38.18.92-.13,1.3-.75l2.43-3.94c.39-.64.95-.95,1.33-.73l8.06,4.52c.39.23,1-.12,1.37-.8l6.18-10.85c.43-.76,1.1-1.09,1.48-.73l4.09,3.82c.33.3.88.11,1.31-.47l1.56-2.08c.36-.49.81-.71,1.14-.57l21.78,8.9-75.26,43.45V222.36A2.47,2.47,0,0,1,119.6,221.33Z",
    style: {
      opacity: 0.1,
      transformOrigin: "156.99px 220.922px"
    },
    className: "animable",
    id: "eleruln8yncza"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.72,223.3l-.87-.64s1.66-.84,1.83-1.62a4.87,4.87,0,0,0,0-1.72l5.85-5.31-2.8.7a31.33,31.33,0,0,0,2.18-5c.3-1.35.48-3.85,1-4.55a2.26,2.26,0,0,0-.51.7L123,218.71c-.4.8-1.08,1.21-1.5.91s-1.13.13-1.52.95l-.36.76a2.47,2.47,0,0,0-.25,1v5.74l.76-3.29Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "124.64px 216.615px"
    },
    id: "elwb0m5nsju7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.48,208.61c.76-.57,0-1.25,0-1.25l1-1.16c-.28-.14-.65,0-1,.33l-1.28,1.28a1,1,0,0,1-.89.35l1.09.46v1.62A3.57,3.57,0,0,1,138.48,208.61Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "137.895px 208.193px"
    },
    id: "elanjr1jni4g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.18,209.85a16.2,16.2,0,0,1-1.25-3.16c-.09-.83,1.25-.72,1.25-.72l-.48-1.11s.22-2.94,1.31-2.33h0l-.37-.2c-.38-.22-.94.09-1.33.73L143.88,207c-.34.57-.82.87-1.19.78Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "145.35px 206.055px"
    },
    id: "el2pxjhwit1c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.34,209.5l2.35-2.23-3.2.18s3.83-4.56,4.77-5.61-5.55,3.2-5.55,3.2,1.94-1.92,1.63-2.16a4.66,4.66,0,0,0-1.58-.28l2.68-3.65s-.95-.07-.47-1.37,1-3.43,1.64-3.19c-.39-.2-1,.13-1.36.81l-6.18,10.85a1.58,1.58,0,0,1-1,.86Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "161.212px 201.916px"
    },
    id: "elghw7y5w9oha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.25,198.53a13.52,13.52,0,0,0-.62,1.43,11.57,11.57,0,0,0,2-1.67c.41-.45.24-1.22.43-1.6s.27-1.74,1.26-1.34l-.46-.18c-.33-.14-.78.08-1.14.57l-1.56,2.08a2.8,2.8,0,0,1-.22.25h0a1.42,1.42,0,0,1-.36.26c-.41.3-.88.67-.72.78S170.25,198.53,170.25,198.53Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "171.074px 197.544px"
    },
    id: "el532a1gh68e8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.51,119.11,288,116.9c-.35-.22-.9.11-1.25.75L276.45,137c-.39.72-1,1-1.35.66l-2.05-2.26c-.32-.36-.94-.07-1.32.62h0c-.38.67-1,1-1.3.67l-1.9-1.74c-.33-.29-.89,0-1.27.61L259,149.43c-.35.59-.86.87-1.2.66l-1.37-.88c-.32-.2-.8,0-1.15.58l-28.18,43.48c-.7,1.08-.33,2.77.54,2.27L290.9,159a3.7,3.7,0,0,0,1.14-2.29V119.42Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "259.387px 156.231px"
    },
    id: "el79csia0rspu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elw39yagwfkqn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.51,119.11,288,116.9c-.35-.22-.9.11-1.25.75L276.45,137c-.39.72-1,1-1.35.66l-2.05-2.26c-.32-.36-.94-.07-1.32.62h0c-.38.67-1,1-1.3.67l-1.9-1.74c-.33-.29-.89,0-1.27.61L259,149.43c-.35.59-.86.87-1.2.66l-1.37-.88c-.32-.2-.8,0-1.15.58l-28.18,43.48c-.7,1.08-.33,2.77.54,2.27L290.9,159a3.7,3.7,0,0,0,1.14-2.29V119.42Z",
    style: {
      opacity: 0.1,
      transformOrigin: "259.387px 156.231px"
    },
    className: "animable",
    id: "elg7wz9ixe44n"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M288,116.9c-.35-.22-.9.11-1.25.75L276.45,137l-.73,1.36-3.58,6.42s4.74-5.51,6.46-7.16,5.07-4.6,4.72-4.56l-1.86.2s1.85-1.3,1.88-1.95-.92-1-.92-1a56.19,56.19,0,0,0,4.48-3.6c.6-.74-2.81.45-2.87-.46s3.65-4.06,3.35-5.22a6.8,6.8,0,0,1,0-2.9c.1-.76.25-1.49,1.36-.79Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "280.44px 130.806px"
    },
    id: "elvw3x9jpnzsn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,180.38s13.21-5.43,13.39-5.44,2.86-10.82,2.87-13.15-2.4.58-2.4-.25-1.31.8-1.3.46,3.81-3.77,3.81-3.77a20.23,20.23,0,0,0-2.27,1.31c-.42.36.66-1.44,3.52-4.6s1.54-3,1.54-3-1.11.78-.82,0,1.07-2.71,1.63-2.36h0l-.45-.29c-.32-.2-.8,0-1.15.58l-18.83,29.05Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "246.755px 164.797px"
    },
    id: "elemmsa477p8o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.64,172a57.38,57.38,0,0,1-8.34,5.39,27.57,27.57,0,0,1-3.87,1.57,10.82,10.82,0,0,1-3.36.45,27.28,27.28,0,0,0-3.84,1,14.56,14.56,0,0,1-7.17-.09,2.08,2.08,0,0,1-1.63-1.38,4,4,0,0,1,1.16-2.75c.78-.85,1.83-.94,2,0,.16-.61.87-.92,1-.43.22-.33.6-.29.59.07,0-.43.49-.91.71-.74-.28-.2-.32-.8-.09-1.34s.71-.94,1-.89a3.49,3.49,0,0,1,1.28-1.92.86.86,0,0,1,1.34.26,1.16,1.16,0,0,1,.14-1.15c.25-.37.64-.5.81-.27a2.09,2.09,0,0,1,.56-1.6c.39-.39.86-.39,1,0a7.29,7.29,0,0,1,.8-3.05c.55-.94,1.64-1.35,1.74-.46a2.21,2.21,0,0,1,.77-1.13c.33-.18.64.1.51.57.3-.51.79-.76,1.06-.55s.28.87,0,1.4c.27-.31.61-.38.78-.16a1.17,1.17,0,0,1-.08,1.09.85.85,0,0,1,.49-.63c.2,0,.33.18.27.48a2,2,0,0,1,1.08-1.47c.45-.13.78.32.7,1a1.38,1.38,0,0,1,.55-1c.27-.16.52,0,.56.31a2,2,0,0,1,.81-1.62c.45-.25.84.1.8.71.25-.51.8-.64.89-.21a3.38,3.38,0,0,1,1.53-2.52c.72-.34,1.33.23,1.29,1.21.37-.68,1.11-.6,1,.1a1.86,1.86,0,0,1,1.11-1.5c.46-.07.71.57.5,1.27.29-.37.71-.3.72.12.2-.7,1-.89,1-.22a2,2,0,0,1,.79-1.39c.38-.23.75,0,.8.44a3.06,3.06,0,0,1,.87-1.8c.45-.42,1-.49,1.25-.17-.14-.11.07-.5.26-.69.85-.82,1.83-.74,2.26,0a4.83,4.83,0,0,1,0,3.37,13.56,13.56,0,0,1-1.77,3.6A28.06,28.06,0,0,1,256.64,172Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "246.887px 169.27px"
    },
    id: "elwbie8236z0g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elyh5lq65fxbh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.64,172a57.38,57.38,0,0,1-8.34,5.39,27.57,27.57,0,0,1-3.87,1.57,10.82,10.82,0,0,1-3.36.45,27.28,27.28,0,0,0-3.84,1,14.56,14.56,0,0,1-7.17-.09,2.08,2.08,0,0,1-1.63-1.38,4,4,0,0,1,1.16-2.75c.78-.85,1.83-.94,2,0,.16-.61.87-.92,1-.43.22-.33.6-.29.59.07,0-.43.49-.91.71-.74-.28-.2-.32-.8-.09-1.34s.71-.94,1-.89a3.49,3.49,0,0,1,1.28-1.92.86.86,0,0,1,1.34.26,1.16,1.16,0,0,1,.14-1.15c.25-.37.64-.5.81-.27a2.09,2.09,0,0,1,.56-1.6c.39-.39.86-.39,1,0a7.29,7.29,0,0,1,.8-3.05c.55-.94,1.64-1.35,1.74-.46a2.21,2.21,0,0,1,.77-1.13c.33-.18.64.1.51.57.3-.51.79-.76,1.06-.55s.28.87,0,1.4c.27-.31.61-.38.78-.16a1.17,1.17,0,0,1-.08,1.09.85.85,0,0,1,.49-.63c.2,0,.33.18.27.48a2,2,0,0,1,1.08-1.47c.45-.13.78.32.7,1a1.38,1.38,0,0,1,.55-1c.27-.16.52,0,.56.31a2,2,0,0,1,.81-1.62c.45-.25.84.1.8.71.25-.51.8-.64.89-.21a3.38,3.38,0,0,1,1.53-2.52c.72-.34,1.33.23,1.29,1.21.37-.68,1.11-.6,1,.1a1.86,1.86,0,0,1,1.11-1.5c.46-.07.71.57.5,1.27.29-.37.71-.3.72.12.2-.7,1-.89,1-.22a2,2,0,0,1,.79-1.39c.38-.23.75,0,.8.44a3.06,3.06,0,0,1,.87-1.8c.45-.42,1-.49,1.25-.17-.14-.11.07-.5.26-.69.85-.82,1.83-.74,2.26,0a4.83,4.83,0,0,1,0,3.37,13.56,13.56,0,0,1-1.77,3.6A28.06,28.06,0,0,1,256.64,172Z",
    style: {
      opacity: 0.45,
      transformOrigin: "246.887px 169.27px"
    },
    className: "animable",
    id: "elhu99hfmxz7i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182,211.06a7.06,7.06,0,0,0,1.64-3.39c.05-.73-.24-1.3-.72-1.37a1.88,1.88,0,0,0-1.54,1c-.23-.62-1.15-.26-1.54.61.23-.92-.19-1.68-.83-1.48a2.65,2.65,0,0,0-1.35,2.17c-.06-.48-.41-.71-.8-.52a2.05,2.05,0,0,0-.92,1.33c-.06-.41-.14-.85-.4-1s-.76.14-.89.64c0-.51-.14-.91-.47-1s-.77.28-1,.76c.58-1.19,0-2.51-.84-2s-1.49,2.41-.94,3c-.26-.37-.93,0-1.23.63l0,.54c-.15-.33-.6-.22-.88.2s-.31,1.06-.05,1.22c-.19-.53-.87-.42-1.3.21a1.9,1.9,0,0,0-.08-1.48c-.24-.29-.8-.08-1,.49.08-.32-.17-.46-.39-.3a2.27,2.27,0,0,0-.55.77c.16-.59-.36-.84-.75-.41a1.87,1.87,0,0,0-.37,1.62c-.33-.27-1,.12-1.28.78.08-.53-.47-.56-.79-.1a2,2,0,0,0-.29,1.52c-.41-.23-1.06.09-1.5.75a2.77,2.77,0,0,0-.47,2.13c.28.85,1.22.41,2,.46a47.3,47.3,0,0,0,6.4-.07c2.16-.18,4.17.21,6.54-1.21A25.81,25.81,0,0,0,182,211.06Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "172.034px 212.608px"
    },
    id: "el6f9ahft2o8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6ao046f1n26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182,211.06a7.06,7.06,0,0,0,1.64-3.39c.05-.73-.24-1.3-.72-1.37a1.88,1.88,0,0,0-1.54,1c-.23-.62-1.15-.26-1.54.61.23-.92-.19-1.68-.83-1.48a2.65,2.65,0,0,0-1.35,2.17c-.06-.48-.41-.71-.8-.52a2.05,2.05,0,0,0-.92,1.33c-.06-.41-.14-.85-.4-1s-.76.14-.89.64c0-.51-.14-.91-.47-1s-.77.28-1,.76c.58-1.19,0-2.51-.84-2s-1.49,2.41-.94,3c-.26-.37-.93,0-1.23.63l0,.54c-.15-.33-.6-.22-.88.2s-.31,1.06-.05,1.22c-.19-.53-.87-.42-1.3.21a1.9,1.9,0,0,0-.08-1.48c-.24-.29-.8-.08-1,.49.08-.32-.17-.46-.39-.3a2.27,2.27,0,0,0-.55.77c.16-.59-.36-.84-.75-.41a1.87,1.87,0,0,0-.37,1.62c-.33-.27-1,.12-1.28.78.08-.53-.47-.56-.79-.1a2,2,0,0,0-.29,1.52c-.41-.23-1.06.09-1.5.75a2.77,2.77,0,0,0-.47,2.13c.28.85,1.22.41,2,.46a47.3,47.3,0,0,0,6.4-.07c2.16-.18,4.17.21,6.54-1.21A25.81,25.81,0,0,0,182,211.06Z",
    style: {
      opacity: 0.45,
      transformOrigin: "172.034px 212.608px"
    },
    className: "animable",
    id: "el4gk8wv53usc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.3,235a6.09,6.09,0,0,1-.49-2.39c0-.59.23-1.24.25-1.82s-.16-1-.56-1.1a.93.93,0,0,0-.57.1c-.06,0-.56.33-.56.44,0-.25-.13-.41-.3-.43a.81.81,0,0,0-.56.18,3,3,0,0,0-.85,1c0-.21-.24-.23-.42-.1a2,2,0,0,0-.47.58c.12-.35-.07-.61-.31-.54a1.49,1.49,0,0,0-.65.7,1.52,1.52,0,0,0-.18-1c-.2-.27-.5-.13-.84.07a2.85,2.85,0,0,0-.9.76,2.23,2.23,0,0,0-.47,1.26c0-.42-.32-.52-.63-.3a3.43,3.43,0,0,0-.77,1.07c.09-.46-.18-.72-.49-.65a2.46,2.46,0,0,0-.94.66,5.17,5.17,0,0,0,.21-1.17c0-.36-.14-.67-.39-.68a1.81,1.81,0,0,0,.42-1.7c-.18-.35-.72-.27-1.09.1a3.51,3.51,0,0,0-.69,1.33.66.66,0,0,1-.7.4v26.3l.89-.51c4.5-3.8,8.89-9.24,13.11-14C132.76,240.89,133.05,237.52,132.3,235Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "126.35px 243.875px"
    },
    id: "elc41fftyx1c9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzojn5uq8dod"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.3,235a6.09,6.09,0,0,1-.49-2.39c0-.59.23-1.24.25-1.82s-.16-1-.56-1.1a.93.93,0,0,0-.57.1c-.06,0-.56.33-.56.44,0-.25-.13-.41-.3-.43a.81.81,0,0,0-.56.18,3,3,0,0,0-.85,1c0-.21-.24-.23-.42-.1a2,2,0,0,0-.47.58c.12-.35-.07-.61-.31-.54a1.49,1.49,0,0,0-.65.7,1.52,1.52,0,0,0-.18-1c-.2-.27-.5-.13-.84.07a2.85,2.85,0,0,0-.9.76,2.23,2.23,0,0,0-.47,1.26c0-.42-.32-.52-.63-.3a3.43,3.43,0,0,0-.77,1.07c.09-.46-.18-.72-.49-.65a2.46,2.46,0,0,0-.94.66,5.17,5.17,0,0,0,.21-1.17c0-.36-.14-.67-.39-.68a1.81,1.81,0,0,0,.42-1.7c-.18-.35-.72-.27-1.09.1a3.51,3.51,0,0,0-.69,1.33.66.66,0,0,1-.7.4v26.3l.89-.51c4.5-3.8,8.89-9.24,13.11-14C132.76,240.89,133.05,237.52,132.3,235Z",
    style: {
      opacity: 0.45,
      transformOrigin: "126.35px 243.875px"
    },
    className: "animable",
    id: "ell70wq95suy"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.35,250.84c9.65-4.55,45.22-26.81,57.12-37.13s23.52-22.85,37.92-30.27c15.31-7.89,48.56-12,54.22-11.53L119.35,258.08Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "193.98px 214.977px"
    },
    id: "elqpdkn614p78",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6y05mmh3t2v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.35,250.84c9.65-4.55,45.22-26.81,57.12-37.13s23.52-22.85,37.92-30.27c15.31-7.89,48.56-12,54.22-11.53L119.35,258.08Z",
    style: {
      opacity: 0.1,
      transformOrigin: "193.98px 214.977px"
    },
    className: "animable",
    id: "el5jhij4ngy3k"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185.49,203.29h0a.75.75,0,0,0-.3.33c-.09.2,0,.4.11.38a.49.49,0,0,0-.22.39c0,.14.11.21.22.13a.38.38,0,0,0-.2.31c0,.13.08.19.18.13a.94.94,0,0,0-.42.38.8.8,0,0,0-.13.59c.05.17.2.15.35.06a.81.81,0,0,0,0,.57c.07.14.25.12.37-.06a.41.41,0,0,0,0,.43c.08.07.22,0,.32-.12a2.71,2.71,0,0,1,.19-.25c.1-.09.2,0,.29-.06s.55-.36.65-.73c.17.19.57,0,.73-.43s-.07-.77-.35-.55c.07-.21.21-.53.12-.67s-.2-.06-.3.07c0-.18,0-.35-.12-.35a.61.61,0,0,0,.2-.37c0-.13-.06-.23-.16-.18a1.22,1.22,0,0,0,.23-.64.18.18,0,0,0-.22-.19.65.65,0,0,0-.33.24c.05-.23,0-.42-.2-.39.1-.14.2-.34.15-.45s-.13-.06-.21,0a.46.46,0,0,0,.08-.38c0-.09-.15-.09-.24,0,.06-.25-.09-.68-.32-.4a.63.63,0,0,0-.1.32,1.18,1.18,0,0,0,0,.34c-.06,0-.17,0-.22.14a.37.37,0,0,0,0,.32.16.16,0,0,0,.2.06c-.1.11-.21.19-.31.3a.9.9,0,0,0-.23.48A.28.28,0,0,0,185.49,203.29Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "186.201px 203.973px"
    },
    id: "el6jzzakoy04",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elu07fbr4727s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.49,203.29h0a.75.75,0,0,0-.3.33c-.09.2,0,.4.11.38a.49.49,0,0,0-.22.39c0,.14.11.21.22.13a.38.38,0,0,0-.2.31c0,.13.08.19.18.13a.94.94,0,0,0-.42.38.8.8,0,0,0-.13.59c.05.17.2.15.35.06a.81.81,0,0,0,0,.57c.07.14.25.12.37-.06a.41.41,0,0,0,0,.43c.08.07.22,0,.32-.12a2.71,2.71,0,0,1,.19-.25c.1-.09.2,0,.29-.06s.55-.36.65-.73c.17.19.57,0,.73-.43s-.07-.77-.35-.55c.07-.21.21-.53.12-.67s-.2-.06-.3.07c0-.18,0-.35-.12-.35a.61.61,0,0,0,.2-.37c0-.13-.06-.23-.16-.18a1.22,1.22,0,0,0,.23-.64.18.18,0,0,0-.22-.19.65.65,0,0,0-.33.24c.05-.23,0-.42-.2-.39.1-.14.2-.34.15-.45s-.13-.06-.21,0a.46.46,0,0,0,.08-.38c0-.09-.15-.09-.24,0,.06-.25-.09-.68-.32-.4a.63.63,0,0,0-.1.32,1.18,1.18,0,0,0,0,.34c-.06,0-.17,0-.22.14a.37.37,0,0,0,0,.32.16.16,0,0,0,.2.06c-.1.11-.21.19-.31.3a.9.9,0,0,0-.23.48A.28.28,0,0,0,185.49,203.29Z",
    style: {
      opacity: 0.25,
      transformOrigin: "186.201px 203.973px"
    },
    className: "animable",
    id: "el6a1q56a3paq"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M191.23,205.18c3.64,0,13.26-8,16.47-10.69s-1.12,2.57.27,2.95S218,188,223.44,184A94.8,94.8,0,0,1,236,176.38c-8.11,1.83-16,4.2-21.58,7.06a97.75,97.75,0,0,0-18,12.4C191.22,201.45,187.6,205.23,191.23,205.18Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "212.881px 190.78px"
    },
    id: "el685aerqolp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2qcwk18qg04"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.16,174.71c-10,9.82-20.11,19.81-31.79,26.55-11.53,6.66-25.92,12.05-33.72,10.53h0l-2.18,1.92C164.57,224,129,246.29,119.35,250.84v7.24l149.26-86.17C265.7,171.67,255.48,172.64,244.16,174.71Z",
    style: {
      opacity: 0.1,
      transformOrigin: "193.98px 214.977px"
    },
    className: "animable",
    id: "elj1vmoexa8if"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.35,241.27S129,230.14,139.59,224s20.38-8.24,28.63-8.1,21.54.56,25.85-1l-74.72,43.14Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "156.71px 236.47px"
    },
    id: "el0wawv2o24ugn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elra7eop55gq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.35,241.27S129,230.14,139.59,224s20.38-8.24,28.63-8.1,21.54.56,25.85-1l-74.72,43.14Z",
    style: {
      opacity: 0.1,
      transformOrigin: "156.71px 236.47px"
    },
    className: "animable",
    id: "el55j7pmrtgi"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.84,224.48l-.39.24-.2.12-.4.25-.17.11-.56.36,0,0-.52.34-.18.12-.38.26-.2.13-.39.27-.16.12-.54.39-.07,0-.48.35-.17.13-.37.27a1.33,1.33,0,0,1-.19.14l-.37.29-.16.12-.52.4-.09.07-.43.34-.17.14-.35.28-.17.14-.37.3-.14.12-.49.41-.09.07-.4.34-.16.14-.33.28-.17.14-.35.31-.12.1-.46.41-.08.07-.38.34-.14.12-.32.29-.13.13-.36.32-.08.08-.43.4-.06,0-.36.34-.11.11-.31.29-.1.1-.36.34,0,0-.39.38,0,0-.34.33-.08.08-.3.3-.07.06-.7.71h0c-.28,1.1.45,1.55,2.58,1.1,7.35-1.54,18.06-13.12,22.52-14.73-.6.26-5,4.77-1.69,3.47,3-1.21,17.18-9.7,35.32-11.42-4.62.15-9.57.12-13.42.05-8.25-.14-18,2-28.63,8.1l-.57.34Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "152.366px 227.116px"
    },
    id: "el5c0s25dq2wj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbgmwwkvi4m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.35,245.48c7-.08,26.74-9.86,32.7-14.27,5-3.67-4.8,6.61-4.8,6.61s20.07-7.43,46.82-22.88l-74.72,43.14Z",
    style: {
      opacity: 0.1,
      transformOrigin: "156.71px 236.51px"
    },
    className: "animable",
    id: "elpq7z3montb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ele08i9wr2tw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.49,218c5.76-1.13,18.8-2,19-2-2.95,0-5.82,0-8.25-.05-8.25-.14-18,2-28.63,8.1s-20.24,17.23-20.24,17.23v1.38a154.62,154.62,0,0,1,15.28-14A57.54,57.54,0,0,1,157.49,218Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "147.93px 229.302px"
    },
    className: "animable",
    id: "el9eqbhuq2kc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.53,230.32s-.45.14-.4,0c-.24.5-.73.75-1,.5,0,0,0,0-.07,0s-.11.08-.17.13c-.22.21-.46,0-.41-.28-.16.17-.36.14-.39-.06a.75.75,0,0,1,.27-.63c-.12-.05-.12-.3-.05-.51a2.24,2.24,0,0,1,.35-.58.64.64,0,0,1-.16-.68,1.14,1.14,0,0,1,.64-.62,1.58,1.58,0,0,1-.06-.45l.11-.16c-.12,0-.2-.11-.17-.28a.53.53,0,0,1,.28-.38.49.49,0,0,1-.22-.31c0-.32.26-.45.35-.75s-.05-.51.07-.77.16-.24.25-.25a.72.72,0,0,1-.1-.34.55.55,0,0,1,.17-.42c.11-.09.22,0,.25.11a2.68,2.68,0,0,1,0,.42l.3-.16c0,.2-.05.43.07.49s.29-.08.4,0a.47.47,0,0,1,0,.57.94.94,0,0,0-.12.22c-.07.23.15.27.17.47s-.12.44-.05.55.07,0,.12,0h.35c.08,0,.18,0,.19.13s-.33.49-.38.77a.57.57,0,0,1,.33-.05.27.27,0,0,1,.1.34c0,.07-.06.14,0,.2s.09,0,.13.08,0,.28-.13.4a.9.9,0,0,0-.25.39.54.54,0,0,1,.31,0,.32.32,0,0,1,.13.33c0,.23-.18.32-.28.51s-.13.38-.24.56S135.77,230.2,135.53,230.32Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "134.918px 227.239px"
    },
    id: "el20zb4ifxb71",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6kjdenjpbg8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.53,230.32s-.45.14-.4,0c-.24.5-.73.75-1,.5,0,0,0,0-.07,0s-.11.08-.17.13c-.22.21-.46,0-.41-.28-.16.17-.36.14-.39-.06a.75.75,0,0,1,.27-.63c-.12-.05-.12-.3-.05-.51a2.24,2.24,0,0,1,.35-.58.64.64,0,0,1-.16-.68,1.14,1.14,0,0,1,.64-.62,1.58,1.58,0,0,1-.06-.45l.11-.16c-.12,0-.2-.11-.17-.28a.53.53,0,0,1,.28-.38.49.49,0,0,1-.22-.31c0-.32.26-.45.35-.75s-.05-.51.07-.77.16-.24.25-.25a.72.72,0,0,1-.1-.34.55.55,0,0,1,.17-.42c.11-.09.22,0,.25.11a2.68,2.68,0,0,1,0,.42l.3-.16c0,.2-.05.43.07.49s.29-.08.4,0a.47.47,0,0,1,0,.57.94.94,0,0,0-.12.22c-.07.23.15.27.17.47s-.12.44-.05.55.07,0,.12,0h.35c.08,0,.18,0,.19.13s-.33.49-.38.77a.57.57,0,0,1,.33-.05.27.27,0,0,1,.1.34c0,.07-.06.14,0,.2s.09,0,.13.08,0,.28-.13.4a.9.9,0,0,0-.25.39.54.54,0,0,1,.31,0,.32.32,0,0,1,.13.33c0,.23-.18.32-.28.51s-.13.38-.24.56S135.77,230.2,135.53,230.32Z",
    style: {
      opacity: 0.25,
      transformOrigin: "134.918px 227.239px"
    },
    className: "animable",
    id: "el0cyhc05bdop5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.7,229h0a.77.77,0,0,0-.3.34c-.09.19,0,.4.11.38a.49.49,0,0,0-.22.39c0,.14.11.2.22.12a.41.41,0,0,0-.2.32c0,.12.08.19.18.13a.94.94,0,0,0-.42.38.8.8,0,0,0-.13.59c0,.17.2.15.35.06a.87.87,0,0,0,0,.57c.07.13.25.12.37-.06-.08.15-.09.35,0,.42s.22,0,.32-.11.12-.19.19-.26.2,0,.29,0c.24,0,.56-.36.65-.73.17.19.57,0,.73-.43s-.07-.77-.35-.55c.07-.21.22-.53.13-.67s-.21-.06-.31.07c0-.18,0-.35-.12-.35a.61.61,0,0,0,.2-.37c0-.13-.06-.23-.16-.19a1.3,1.3,0,0,0,.24-.63c0-.15-.11-.21-.22-.19a.71.71,0,0,0-.34.23c0-.22,0-.41-.2-.38a.65.65,0,0,0,.16-.46c0-.08-.14-.06-.22,0a.44.44,0,0,0,.08-.37c0-.1-.15-.1-.24,0,.06-.25-.09-.68-.32-.4a.6.6,0,0,0-.1.32,1.22,1.22,0,0,0,0,.34c-.06,0-.16,0-.22.14a.37.37,0,0,0,0,.32.16.16,0,0,0,.2.06c-.1.11-.21.18-.31.3a.94.94,0,0,0-.23.48A.28.28,0,0,0,139.7,229Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "140.411px 229.713px"
    },
    id: "el5ww1snxv41m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elw8782okp2i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.7,229h0a.77.77,0,0,0-.3.34c-.09.19,0,.4.11.38a.49.49,0,0,0-.22.39c0,.14.11.2.22.12a.41.41,0,0,0-.2.32c0,.12.08.19.18.13a.94.94,0,0,0-.42.38.8.8,0,0,0-.13.59c0,.17.2.15.35.06a.87.87,0,0,0,0,.57c.07.13.25.12.37-.06-.08.15-.09.35,0,.42s.22,0,.32-.11.12-.19.19-.26.2,0,.29,0c.24,0,.56-.36.65-.73.17.19.57,0,.73-.43s-.07-.77-.35-.55c.07-.21.22-.53.13-.67s-.21-.06-.31.07c0-.18,0-.35-.12-.35a.61.61,0,0,0,.2-.37c0-.13-.06-.23-.16-.19a1.3,1.3,0,0,0,.24-.63c0-.15-.11-.21-.22-.19a.71.71,0,0,0-.34.23c0-.22,0-.41-.2-.38a.65.65,0,0,0,.16-.46c0-.08-.14-.06-.22,0a.44.44,0,0,0,.08-.37c0-.1-.15-.1-.24,0,.06-.25-.09-.68-.32-.4a.6.6,0,0,0-.1.32,1.22,1.22,0,0,0,0,.34c-.06,0-.16,0-.22.14a.37.37,0,0,0,0,.32.16.16,0,0,0,.2.06c-.1.11-.21.18-.31.3a.94.94,0,0,0-.23.48A.28.28,0,0,0,139.7,229Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "140.411px 229.713px"
    },
    className: "animable",
    id: "elkw4mdgf1va"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M292,158.38V134.62c-8.5,3.59-16.24,11.15-25.41,21.6-12.68,14.45-23.94,30.65-35.12,37.11Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "261.735px 163.975px"
    },
    id: "elb2g9q9s2iv6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elz1ebooq122h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292,158.38V134.62c-8.5,3.59-16.24,11.15-25.41,21.6-12.68,14.45-23.94,30.65-35.12,37.11Z",
    style: {
      opacity: 0.2,
      transformOrigin: "261.735px 163.975px"
    },
    className: "animable",
    id: "elzt9zusth26j"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M266.63,156.22c-4.82,5.5-9.44,11.18-13.93,16.48h0a58.85,58.85,0,0,1,7.1-6.27c4.7-3.63,9.63-7.25,8.81-8.1s1.65-2,6.74-4.45c4.35-2.09,12.4-8.94,16.69-14.89v-4.37C283.54,138.21,275.8,145.77,266.63,156.22Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "272.37px 153.66px"
    },
    id: "elzp2zasuxbqh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elisrzrktjv2f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.63,156.22c-4.82,5.5-9.44,11.18-13.93,16.48h0a58.85,58.85,0,0,1,7.1-6.27c4.7-3.63,9.63-7.25,8.81-8.1s1.65-2,6.74-4.45c4.35-2.09,12.4-8.94,16.69-14.89v-4.37C283.54,138.21,275.8,145.77,266.63,156.22Z",
    style: {
      opacity: 0.1,
      transformOrigin: "272.37px 153.66px"
    },
    className: "animable",
    id: "el982l16kwu7j"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elkgt5zyvsoz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292,143.59c-11.2,11.7-25.13,18.59-24.05,19.64s7.09-.12,4.92,2.3A84.18,84.18,0,0,1,254.57,180L292,158.38Z",
    style: {
      opacity: 0.1,
      transformOrigin: "273.285px 161.795px"
    },
    className: "animable",
    id: "elo6h8f3x2tvf"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M266.63,156.22l-.62.72c.24-.25,7.65-7.79,11.83-11.6s11-8.33,14.2-9.31v-1.41C283.54,138.21,275.8,145.77,266.63,156.22Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "279.025px 145.78px"
    },
    id: "el3c72hwgjtnb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkj6nawnz5eo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.63,156.22l-.62.72c.24-.25,7.65-7.79,11.83-11.6s11-8.33,14.2-9.31v-1.41C283.54,138.21,275.8,145.77,266.63,156.22Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "279.025px 145.78px"
    },
    className: "animable",
    id: "elf4vbjx6x1he"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M268.82,157s-.45.14-.4,0c-.25.49-.74.75-1,.5,0,0,0-.05-.07-.05s-.11.08-.17.13c-.22.21-.47,0-.41-.28-.16.17-.36.14-.4-.06a.79.79,0,0,1,.28-.63c-.12,0-.13-.3-.05-.51a2.49,2.49,0,0,1,.35-.59.6.6,0,0,1-.16-.67,1.08,1.08,0,0,1,.64-.62,1.58,1.58,0,0,1-.06-.45l.11-.16c-.12,0-.2-.11-.17-.28a.5.5,0,0,1,.28-.38.49.49,0,0,1-.22-.31c0-.32.26-.45.34-.75s0-.51.08-.77.16-.24.25-.25a.85.85,0,0,1-.11-.34.6.6,0,0,1,.18-.42c.11-.09.21,0,.25.11a2.68,2.68,0,0,1,.05.42l.3-.16c0,.19-.05.43.06.49s.3-.08.41,0a.46.46,0,0,1,0,.56,1.27,1.27,0,0,0-.12.23c-.08.23.15.27.17.47s-.12.44-.05.55.07,0,.12,0h.35c.08,0,.18,0,.19.13s-.33.49-.38.77a.56.56,0,0,1,.33,0,.26.26,0,0,1,.1.33c0,.07-.06.15,0,.21s.09,0,.13.07,0,.29-.13.41a.9.9,0,0,0-.25.39.54.54,0,0,1,.31,0,.3.3,0,0,1,.12.33c0,.23-.17.32-.27.51s-.13.38-.24.56S269.06,156.91,268.82,157Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "268.225px 153.869px"
    },
    id: "el0bqnv8ousql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfvwky17c1el"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.82,157s-.45.14-.4,0c-.25.49-.74.75-1,.5,0,0,0-.05-.07-.05s-.11.08-.17.13c-.22.21-.47,0-.41-.28-.16.17-.36.14-.4-.06a.79.79,0,0,1,.28-.63c-.12,0-.13-.3-.05-.51a2.49,2.49,0,0,1,.35-.59.6.6,0,0,1-.16-.67,1.08,1.08,0,0,1,.64-.62,1.58,1.58,0,0,1-.06-.45l.11-.16c-.12,0-.2-.11-.17-.28a.5.5,0,0,1,.28-.38.49.49,0,0,1-.22-.31c0-.32.26-.45.34-.75s0-.51.08-.77.16-.24.25-.25a.85.85,0,0,1-.11-.34.6.6,0,0,1,.18-.42c.11-.09.21,0,.25.11a2.68,2.68,0,0,1,.05.42l.3-.16c0,.19-.05.43.06.49s.3-.08.41,0a.46.46,0,0,1,0,.56,1.27,1.27,0,0,0-.12.23c-.08.23.15.27.17.47s-.12.44-.05.55.07,0,.12,0h.35c.08,0,.18,0,.19.13s-.33.49-.38.77a.56.56,0,0,1,.33,0,.26.26,0,0,1,.1.33c0,.07-.06.15,0,.21s.09,0,.13.07,0,.29-.13.41a.9.9,0,0,0-.25.39.54.54,0,0,1,.31,0,.3.3,0,0,1,.12.33c0,.23-.17.32-.27.51s-.13.38-.24.56S269.06,156.91,268.82,157Z",
    style: {
      opacity: 0.45,
      transformOrigin: "268.225px 153.869px"
    },
    className: "animable",
    id: "el6d92hm3r1xp"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263,161h0a.84.84,0,0,0-.3.34c-.08.19,0,.4.11.38a.48.48,0,0,0-.21.39c0,.14.11.2.22.12a.37.37,0,0,0-.2.31c0,.13.08.2.17.14a1,1,0,0,0-.42.38.83.83,0,0,0-.13.59c.06.17.21.14.35.05a.9.9,0,0,0,0,.58c.07.13.26.12.38-.06a.4.4,0,0,0,0,.42c.08.08.22,0,.33-.11a2.48,2.48,0,0,1,.19-.26c.1-.08.19-.05.29-.05s.55-.36.65-.73c.17.19.57,0,.72-.43s-.07-.77-.35-.55c.08-.21.22-.53.13-.67s-.2-.07-.31.07c.05-.18,0-.35-.12-.35a.59.59,0,0,0,.2-.37c0-.14-.05-.23-.15-.19a1.19,1.19,0,0,0,.23-.64.18.18,0,0,0-.22-.18.69.69,0,0,0-.34.23c.06-.23,0-.42-.19-.38.09-.14.19-.34.15-.46s-.13-.06-.22,0a.41.41,0,0,0,.08-.37c0-.1-.14-.1-.24,0,.07-.24-.08-.67-.31-.39a.46.46,0,0,0-.1.32.94.94,0,0,0,0,.34c-.06-.05-.17,0-.23.14a.37.37,0,0,0,0,.32.15.15,0,0,0,.2.06c-.1.11-.21.18-.31.29a1,1,0,0,0-.24.49A.29.29,0,0,0,263,161Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "263.714px 161.695px"
    },
    id: "elesdelshjq9u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elx26uxarcivo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263,161h0a.84.84,0,0,0-.3.34c-.08.19,0,.4.11.38a.48.48,0,0,0-.21.39c0,.14.11.2.22.12a.37.37,0,0,0-.2.31c0,.13.08.2.17.14a1,1,0,0,0-.42.38.83.83,0,0,0-.13.59c.06.17.21.14.35.05a.9.9,0,0,0,0,.58c.07.13.26.12.38-.06a.4.4,0,0,0,0,.42c.08.08.22,0,.33-.11a2.48,2.48,0,0,1,.19-.26c.1-.08.19-.05.29-.05s.55-.36.65-.73c.17.19.57,0,.72-.43s-.07-.77-.35-.55c.08-.21.22-.53.13-.67s-.2-.07-.31.07c.05-.18,0-.35-.12-.35a.59.59,0,0,0,.2-.37c0-.14-.05-.23-.15-.19a1.19,1.19,0,0,0,.23-.64.18.18,0,0,0-.22-.18.69.69,0,0,0-.34.23c.06-.23,0-.42-.19-.38.09-.14.19-.34.15-.46s-.13-.06-.22,0a.41.41,0,0,0,.08-.37c0-.1-.14-.1-.24,0,.07-.24-.08-.67-.31-.39a.46.46,0,0,0-.1.32.94.94,0,0,0,0,.34c-.06-.05-.17,0-.23.14a.37.37,0,0,0,0,.32.15.15,0,0,0,.2.06c-.1.11-.21.18-.31.29a1,1,0,0,0-.24.49A.29.29,0,0,0,263,161Z",
    style: {
      opacity: 0.25,
      transformOrigin: "263.714px 161.695px"
    },
    className: "animable",
    id: "elixaitbt95bi"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.35,258.08V244.79s.91-1.81,2.09-1.68c.66.07,1,1.65.31,3,0,0,1.1-.63.89.65,0,0,.62-1,1.09-.7s-.21,1.42-.21,1.42.7-.09.38.83c0,0,.25-.71.72-.78,0,0-.15-1.42.79-2s1.66.2,1.24,1.54c0,0,.89,0,.47,1a1.37,1.37,0,0,1,.89-1,2.94,2.94,0,0,1,1-2.35,5.24,5.24,0,0,1,1.2-3.29c1.25-1.41,1.78-1.09,1.78-1.09s.31-1,1-1.19.52.93.52.93.62-.57,1-.23,0,1.77,0,1.77.52-.46.78.12c0,0,.37-1.19,1.2-1.4s.68,1.11.68,1.11a.82.82,0,0,1,.68-.32c.47,0,.31.91.31.91s.73-1,1.15-.93.52.79.52.79a3.81,3.81,0,0,1,1.31-1.27c.67-.29.88.48.88.48s.37-.83.68-.73.63,1.21.63,1.21.73-.49,1.14-.19a1.14,1.14,0,0,1,.42.85s1.46-.39,1.46.29Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "132.85px 248.604px"
    },
    id: "elqbhi0fiqq4f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnsutaa13p6f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.35,258.08V244.79s.91-1.81,2.09-1.68c.66.07,1,1.65.31,3,0,0,1.1-.63.89.65,0,0,.62-1,1.09-.7s-.21,1.42-.21,1.42.7-.09.38.83c0,0,.25-.71.72-.78,0,0-.15-1.42.79-2s1.66.2,1.24,1.54c0,0,.89,0,.47,1a1.37,1.37,0,0,1,.89-1,2.94,2.94,0,0,1,1-2.35,5.24,5.24,0,0,1,1.2-3.29c1.25-1.41,1.78-1.09,1.78-1.09s.31-1,1-1.19.52.93.52.93.62-.57,1-.23,0,1.77,0,1.77.52-.46.78.12c0,0,.37-1.19,1.2-1.4s.68,1.11.68,1.11a.82.82,0,0,1,.68-.32c.47,0,.31.91.31.91s.73-1,1.15-.93.52.79.52.79a3.81,3.81,0,0,1,1.31-1.27c.67-.29.88.48.88.48s.37-.83.68-.73.63,1.21.63,1.21.73-.49,1.14-.19a1.14,1.14,0,0,1,.42.85s1.46-.39,1.46.29Z",
    style: {
      opacity: 0.45,
      transformOrigin: "132.85px 248.604px"
    },
    className: "animable",
    id: "ell8w4pnk1t2i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.68,246.35c-.53-.23-1.3.28-1.87,1.07-.21-.58-.74-1.74-1.32-1.47a3.37,3.37,0,0,0-1.47,1.82c-.15-.51-.82-.35-1.18.28,0-.38-.21-.61-.48-.54a1.28,1.28,0,0,0-.72.86c.16-1-.16-1.76-.75-1.87s-1.4.49-1.89,1.39a3.66,3.66,0,0,0-.44,2.21.39.39,0,0,0-.4-.18,1.37,1.37,0,0,0-.86.81.7.7,0,0,0-1-.16,2.66,2.66,0,0,0-1,1.33c0-.84-.52-1.35-1.15-1.19a3,3,0,0,0-1.7,1.9c.11-.68-.14-1.23-.57-1.28s-1,.42-1.34,1.08a4.14,4.14,0,0,0,.08-1.66.87.87,0,0,0-.39-.67.69.69,0,0,0-.74.42c.62-1.09.68-2.52.13-3a1,1,0,0,0-1.25,0v10.56l20.53-11.85C139.82,246.18,139.75,246.38,139.68,246.35Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "129.635px 251.985px"
    },
    id: "eljflqcl15yd8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elq5ds603v0q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.68,246.35c-.53-.23-1.3.28-1.87,1.07-.21-.58-.74-1.74-1.32-1.47a3.37,3.37,0,0,0-1.47,1.82c-.15-.51-.82-.35-1.18.28,0-.38-.21-.61-.48-.54a1.28,1.28,0,0,0-.72.86c.16-1-.16-1.76-.75-1.87s-1.4.49-1.89,1.39a3.66,3.66,0,0,0-.44,2.21.39.39,0,0,0-.4-.18,1.37,1.37,0,0,0-.86.81.7.7,0,0,0-1-.16,2.66,2.66,0,0,0-1,1.33c0-.84-.52-1.35-1.15-1.19a3,3,0,0,0-1.7,1.9c.11-.68-.14-1.23-.57-1.28s-1,.42-1.34,1.08a4.14,4.14,0,0,0,.08-1.66.87.87,0,0,0-.39-.67.69.69,0,0,0-.74.42c.62-1.09.68-2.52.13-3a1,1,0,0,0-1.25,0v10.56l20.53-11.85C139.82,246.18,139.75,246.38,139.68,246.35Z",
    style: {
      opacity: 0.65,
      transformOrigin: "129.635px 251.985px"
    },
    className: "animable",
    id: "eli2hud15v7b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M253.74,108.06a1.35,1.35,0,0,0-1.22-1.21,1.81,1.81,0,0,0-1,.22,6.82,6.82,0,0,0-.9.8c-.37-.66-.37-1.58-.82-2.16a2.15,2.15,0,0,0-1.48-.84,2,2,0,0,0-1.43.43,6.34,6.34,0,0,0-1.73,2.8,9.66,9.66,0,0,0-.34,6.1c-.38.25-.58,1.09-.32,1.29-.33-.36-1.09.18-1.33.93a1.05,1.05,0,0,0-1.55-.47c-.65.42-1.23,1.78-.87,2.29-.27-.53-1.23.27-1.29,1.07,0-1.06-.9-1.16-1.69-.77a3.77,3.77,0,0,0-1.72,1.71c-.41.85-.36,2,.21,2-.28-.15-.73.1-1,.57a1.71,1.71,0,0,0-.23,1.43c-.26-.23-.73-.18-1.07.3s-.23,1.29.17,1.06a3.72,3.72,0,0,0-1.22,1.19,2.41,2.41,0,0,1-1.37,1,1,1,0,0,0-.64.25l-.06.37-.78.47a1,1,0,0,0-.27.2.51.51,0,0,0-.12.36c0,.15.2.09.33,0a24,24,0,0,0,4.77-2.77c1.09,1.48,3.51.32,4.85-2.26a.78.78,0,0,1,.23-.32.27.27,0,0,1,.15,0c.48,0,1.08-.71,1.28-1.44.05.4.39.5.72.3a2.5,2.5,0,0,0,.82-1.12,2.14,2.14,0,0,0,2.24-.15,5.88,5.88,0,0,0,1.64-1.54c.09-.12,1.08-1.69,1-1.71.36.23,1-.27,1.27-1a.89.89,0,0,0,1.16.23c.11,0,1.29-.75,1.14-1.07.47,1,1.85.8,2.8-.47.51.67,1.45.66,2.34,0a6.05,6.05,0,0,0,1.95-3.27c.94.18,2.18-.51,3.14-1.75-.09.75.63.94,1.09.29.33.56,1.42-.41,1.45-1.3.37.41,1.3-.38,1.43-1.24.17.37.64.19,1-.14s.73-.82,1.11-1.11c.81-.61,1.77-.41,2.38-1.47l2.48-1.3,3.81-2c.45-.23.88-.51,1.32-.79a.27.27,0,0,0,.08-.07.2.2,0,0,0,0-.23s-.11,0-.18,0a1.56,1.56,0,0,0-.51.24c-.11.07-.24.17-.32.11s-.07-.25-.15-.32-.22,0-.34.11l-.91.67a.33.33,0,0,1-.17.08c-.05,0-.08,0-.12-.09-.28-.31-.65,0-1,.11a6.26,6.26,0,0,0-2.36,1.14,2.76,2.76,0,0,1-.9.61,1.4,1.4,0,0,1-.67-.15,2.78,2.78,0,0,0-1.81.64,3.69,3.69,0,0,0-1.8,2c-.6-.17-1.49.5-2,1.49a.79.79,0,0,0-1.33-.48c.1-.8-.5-1.09-1.07-.78a5.85,5.85,0,0,0-1.58,1.68.74.74,0,0,0,0-.94c-.19-.17-.47-.18-.6-.43a3.78,3.78,0,0,1-.14-.64c-.22-.92-1.43-.6-2,.52.15-1,0-1.93-.58-2.15s-1.53.57-1.75,1.57C255,106.31,254.05,107.06,253.74,108.06Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "253.678px 115.646px"
    },
    id: "elgrupitcmf1b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.83,105.54c-.59-.35-1.61.28-2.16,1.35-.35-.09-.85.28-1.14.84-.84,0-1.92,1-2.51,2.22-.1-.58-.91-.25-1.13.46l-.27-1.57c-.35,0-.85.65-.85,1.16-.37-.47-1.31,1.23-1.8,1-.15-.07-.21-.31-.33-.43-.4-.37-1.14.52-1.62,1.29.32-1.27-.87-1.61-1.66-.65a5.38,5.38,0,0,0-1,3.58c-.34-.2-.89.09-1.24.65-.33-1.08-1.65-.93-2.51.28.56-1.17-.11-2.23-1-1.89a5.88,5.88,0,0,0-2.25,2.65c-.35-.25-1,0-1.37.64.28-.56,0-1.11-.44-.9a2.23,2.23,0,0,0-.89,1.46,4.68,4.68,0,0,0,0,1.59c-.4.62-.92.39-1.26.12a.78.78,0,0,0-1.26.32c-.07-.58-.62-.62-1.09-.27a6.07,6.07,0,0,0-1.24,1.57c-.31-.52-1.12-.15-1.64.6a5.64,5.64,0,0,0-.85,2.57c-.47-.34-1.35.19-1.8,1.1-.44-.57-1.41.33-2.16,1a6.06,6.06,0,0,1-2.34,1.42,2.09,2.09,0,0,1-.49,0h0a1,1,0,0,0-.64.25l-.06.37-.78.47a1,1,0,0,0-.27.2.51.51,0,0,0-.12.36c0,.15.2.09.33,0a24,24,0,0,0,4.77-2.77c1.09,1.48,3.51.32,4.85-2.26a.78.78,0,0,1,.23-.32.27.27,0,0,1,.15,0c.48,0,1.08-.71,1.28-1.44.05.4.39.5.72.3a2.5,2.5,0,0,0,.82-1.12,2.14,2.14,0,0,0,2.24-.15,5.88,5.88,0,0,0,1.64-1.54c.09-.12,1.08-1.69,1-1.71.36.23,1-.27,1.27-1a.89.89,0,0,0,1.16.23c.11,0,1.29-.75,1.14-1.07.47,1,1.85.8,2.8-.47.51.67,1.45.66,2.34,0a6.05,6.05,0,0,0,1.95-3.27c.94.18,2.18-.51,3.14-1.75-.09.75.63.94,1.09.29.33.56,1.42-.41,1.45-1.3.37.41,1.3-.38,1.43-1.24.17.37.64.19,1-.14s.73-.82,1.11-1.11c.81-.61,1.77-.41,2.38-1.47l2.48-1.3,3.81-2c.45-.23.88-.51,1.32-.79l.07-.06A20.79,20.79,0,0,0,269.83,105.54Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "253.645px 115.666px"
    },
    id: "el2us0ekix0s2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.48,173.35c-.51-.51-1.4-.34-2.16.41a5.22,5.22,0,0,0-1.39,3.12c-.31-.15-.86.75-.67,1.11-.19-.46-1,.07-1.1.75-.14-.27-.47-.25-.75,0a1.62,1.62,0,0,0-.4,1.13c-.43.1-.59.56-1,.87s-.54.08-.79.35c-.05.05-.1.13-.08.19s0,0,.08,0a3.48,3.48,0,0,0,2-1c.58.18,1.41-.38,1.93-1.28.3.42.93.26,1.47-.17a9.35,9.35,0,0,0,1.5-1.75c.21.6.86.6,1.45.23a7.82,7.82,0,0,0,1.67-1.68c.55.87,2-.73,2.64-1.73.09.27.37.29.63.09a2,2,0,0,0,.58-1c-.09.31,2.1.16,1.83-1,.35.5,1.3-.12,1.59-1,.25.36.78.23,1.24-.15a7.6,7.6,0,0,0,1.25-1.5c.65.5,1.83-.12,2.53-1.33.25.22.76-.15.94-.67.1.52.86.11,1-.53,0,.26.23.37.44.25a1.11,1.11,0,0,0,.45-.74c.32.15.81-.12,1.14-.63.62.09,1.46-.54,2-1.48a1.39,1.39,0,0,0-1,.77c-.06-.37-.46-.28-.77-.05s-.64.6-.91.61-.42-.21-.77-.06a2.21,2.21,0,0,0-.86.84s-.06-.12-.08-.19-.23-.23-.41-.15a1.77,1.77,0,0,0-.74.64,1.85,1.85,0,0,0-1.48-.4,2.59,2.59,0,0,0-1.53,1.68c-.24-.48-1-.21-1.36.5-.15-.56-.52-.95-1-.86a2.09,2.09,0,0,0-1.31,1.48c-.12-.23-.53.1-.57.45-.13-.57-.79-.52-1.22.09a.89.89,0,0,0,.13-.85c-.12-.18-.4-.1-.59.16.33-.39.27-1.05,0-1.12s-.71.28-1,.68c.39-.86,0-1.76-.63-1.4a1.34,1.34,0,0,0,.19-1,.54.54,0,0,0-.57-.38,2.15,2.15,0,0,0-1.51,1.22,3.12,3.12,0,0,0-.38,2.16,2.69,2.69,0,0,0-.83.79c-.23.37-.31.93-.09,1a3.56,3.56,0,0,0,.05.76.75.75,0,0,0,.41.36.84.84,0,0,0-.34.06C146,172.22,145.26,173.12,145.48,173.35Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "151.318px 172.758px"
    },
    id: "ely9v9ak67bll",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.7,166.55c-.13-.25-.52.2-.72.58,0-.25-.18-.38-.37-.29a1,1,0,0,0-.41.67c0-.43-.6-.29-.81.2a1.9,1.9,0,0,0-1.43.82c0-.29-.23-.43-.46-.33a1.16,1.16,0,0,0-.54.78c-.05-.29-.4-.17-.61.13a3.1,3.1,0,0,0-.37,1c0-.13-.22-.11-.34,0,.14-.31-.06-.57-.28-.48a1.79,1.79,0,0,0-.63.65c-.24.08-.18-.43-.28-.66s-.62,0-.9.39-.49.94-.79,1.34c-.14-.41-.76-.14-1,.43a.34.34,0,0,0-.54-.25,1.35,1.35,0,0,0-.53.88c-.13-.37-.55-.32-.9,0a4.47,4.47,0,0,0-.87,1.31c-.15-.27-.49-.27-.8,0,.26-.68-.09-1.25-.56-1.1a2.59,2.59,0,0,0-1.22,1.48,7.58,7.58,0,0,0-.34,1.12,5.93,5.93,0,0,0-.2.9c0-.35-.28-.54-.57-.48a1.37,1.37,0,0,0-.81.75,1.12,1.12,0,0,0,0-.37.25.25,0,0,0-.4-.16,1,1,0,0,0-.41.63c0-.69-.34-.73-.82-.21a3,3,0,0,0-.75,1.92,3.38,3.38,0,0,0-2.25,1.58c-.37-.26-1,.7-1.5.87l-.2,0-.06.05c-.27.2-.54.08-.79.35-.05.05-.1.13-.08.19s0,0,.08,0a3.48,3.48,0,0,0,2-1c.58.18,1.41-.38,1.93-1.28.3.42.93.26,1.47-.17a9.35,9.35,0,0,0,1.5-1.75c.21.6.86.6,1.45.23a7.82,7.82,0,0,0,1.67-1.68c.55.87,2-.73,2.64-1.73.09.27.37.29.63.09a2,2,0,0,0,.58-1c-.09.31,2.1.16,1.83-1,.35.5,1.3-.12,1.59-1,.25.36.78.23,1.24-.15a7.6,7.6,0,0,0,1.25-1.5c.65.5,1.83-.12,2.53-1.33.25.22.76-.15.94-.67.1.52.86.11,1-.53,0,.26.23.37.44.25a1.11,1.11,0,0,0,.45-.74c.32.15.81-.12,1.14-.63a1.54,1.54,0,0,0,1.11-.42,4.88,4.88,0,0,0-1.39.32A3.34,3.34,0,0,0,161.7,166.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "150.893px 173.248px"
    },
    id: "elakqsoh0o95u",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Info--inject-112",
    className: "animable",
    style: {
      transformOrigin: "204.117px 328.077px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169,278.65c.17-.1.29-.1.36,0a1,1,0,0,1,.22.46l3.68,12.5a.76.76,0,0,1,0,.16,1.19,1.19,0,0,1-.12.51.79.79,0,0,1-.28.35l-1.09.62c-.19.12-.34.13-.42.05a.69.69,0,0,1-.16-.29l-.65-2.19-4.75,2.74-.64,2.94a2.55,2.55,0,0,1-.17.48,1,1,0,0,1-.42.44l-1.08.62a.22.22,0,0,1-.29,0,.5.5,0,0,1-.12-.37.88.88,0,0,1,0-.17l3.68-16.75A3.22,3.22,0,0,1,167,280a.85.85,0,0,1,.36-.41Zm.83,9.68-1.65-5.64-1.66,7.55Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "168.165px 288.335px"
    },
    id: "elrt76kv8fr49",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.81,286.81a1.19,1.19,0,0,1-.12.51.69.69,0,0,1-.29.35l-1.14.66a.21.21,0,0,1-.28,0,.5.5,0,0,1-.12-.37v-5.88a3.55,3.55,0,0,0-.42-2c-.28-.39-.72-.42-1.3-.08a3,3,0,0,0-1.25,1.55,6.35,6.35,0,0,0-.46,2.49v5.88a1.19,1.19,0,0,1-.12.51.8.8,0,0,1-.29.35l-1.14.66a.22.22,0,0,1-.28,0,.5.5,0,0,1-.12-.37V280.26a1.19,1.19,0,0,1,.12-.51.79.79,0,0,1,.28-.35l1.14-.66a.24.24,0,0,1,.29,0,.5.5,0,0,1,.12.37v.54a8.62,8.62,0,0,1,.92-1.53,4.22,4.22,0,0,1,1.24-1.11,2.56,2.56,0,0,1,1.54-.45,1.42,1.42,0,0,1,1,.61,3.38,3.38,0,0,1,.53,1.42,10.87,10.87,0,0,1,.16,2Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "178.15px 284.024px"
    },
    id: "el6e27exmkh7i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.82,272.28a2.75,2.75,0,0,1,.83-.34,1.83,1.83,0,0,1,.65,0,1.15,1.15,0,0,1,.47.18,1.81,1.81,0,0,1,.32.27v-4.93a1.19,1.19,0,0,1,.12-.51.74.74,0,0,1,.28-.35l1.14-.66a.22.22,0,0,1,.29,0,.5.5,0,0,1,.12.37v15.18a1.19,1.19,0,0,1-.12.51.75.75,0,0,1-.29.35l-1.14.66a.2.2,0,0,1-.28,0,.5.5,0,0,1-.12-.37v-.53c-.08.18-.19.4-.32.63a6.86,6.86,0,0,1-.47.73,7,7,0,0,1-.65.72,4.72,4.72,0,0,1-.83.62,2.06,2.06,0,0,1-1.36.33,1.66,1.66,0,0,1-1-.6,3.72,3.72,0,0,1-.68-1.35,7.67,7.67,0,0,1-.28-1.89c0-.22,0-.49,0-.8s0-.58,0-.82a12.16,12.16,0,0,1,.28-2.2,11.78,11.78,0,0,1,.68-2.13,7.92,7.92,0,0,1,1-1.8A4.4,4.4,0,0,1,186.82,272.28Zm-1.4,6.41a9.25,9.25,0,0,0,0,1.29c.06,1,.26,1.58.6,1.82a1.11,1.11,0,0,0,1.25-.06,3.28,3.28,0,0,0,1.24-1.39,5.74,5.74,0,0,0,.58-2.25c0-.24,0-.54,0-.9s0-.64,0-.86a2.16,2.16,0,0,0-.58-1.56,1,1,0,0,0-1.24,0,3.33,3.33,0,0,0-1.25,1.38A6.05,6.05,0,0,0,185.42,278.69Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "187.271px 275.519px"
    },
    id: "elcnmpqxv7gir",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.49,278.89l-3-8.88a.66.66,0,0,1,0-.15,1.19,1.19,0,0,1,.12-.51.74.74,0,0,1,.28-.35l1.13-.65a.27.27,0,0,1,.32,0,.5.5,0,0,1,.18.27l2,6,2-8.3a1.76,1.76,0,0,1,.19-.48.8.8,0,0,1,.31-.36l1.13-.66a.21.21,0,0,1,.28,0,.48.48,0,0,1,.12.37,1,1,0,0,1,0,.17l-4.22,17.52a2.07,2.07,0,0,1-.18.48,1,1,0,0,1-.32.37l-1.13.65a.22.22,0,0,1-.28,0,.52.52,0,0,1-.12-.38,1,1,0,0,1,0-.17Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "196.52px 274.598px"
    },
    id: "elgc1ecszg03o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.68,257.46l-4.93,2.85a.22.22,0,0,1-.28,0,.5.5,0,0,1-.12-.37v-1.65a1.19,1.19,0,0,1,.12-.51.79.79,0,0,1,.28-.35l6.56-3.78a.21.21,0,0,1,.28,0,.5.5,0,0,1,.12.37v9.79a11.22,11.22,0,0,1-1.08,5.12,7.75,7.75,0,0,1-3.1,3.31,4.34,4.34,0,0,1-1.84.66,1.83,1.83,0,0,1-1.27-.37,2.36,2.36,0,0,1-.76-1.18,6.77,6.77,0,0,1-.3-1.81.94.94,0,0,1,.11-.52.77.77,0,0,1,.29-.34L206,268a.31.31,0,0,1,.25,0c.08,0,.14.1.15.23a3.41,3.41,0,0,0,.22.78,1.2,1.2,0,0,0,.4.54.94.94,0,0,0,.63.17,2.09,2.09,0,0,0,.9-.32,3.92,3.92,0,0,0,1.6-1.76,6.28,6.28,0,0,0,.55-2.75Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "208.536px 263.252px"
    },
    id: "elhash7ue09qt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.29,254.11a2.92,2.92,0,0,1,1.5-.47,1.75,1.75,0,0,1,1.15.42,2.68,2.68,0,0,1,.78,1.17,5.48,5.48,0,0,1,.34,1.79c0,.14,0,.31,0,.53v1.28c0,.21,0,.39,0,.53a11.07,11.07,0,0,1-.34,2.19,9.88,9.88,0,0,1-.78,2.05,8.54,8.54,0,0,1-1.15,1.75,5.92,5.92,0,0,1-1.5,1.26,3.12,3.12,0,0,1-1.5.47,1.8,1.8,0,0,1-1.15-.41,2.7,2.7,0,0,1-.78-1.16,6.19,6.19,0,0,1-.34-1.79q0-.21,0-.51v-1.29c0-.21,0-.4,0-.54a9.78,9.78,0,0,1,.34-2.19,10.27,10.27,0,0,1,.78-2.07,8.54,8.54,0,0,1,1.15-1.75A5.92,5.92,0,0,1,218.29,254.11Zm1.82,4.16a3,3,0,0,0-.22-1.07,1,1,0,0,0-.43-.5.74.74,0,0,0-.55-.06,1.88,1.88,0,0,0-.62.25,3.2,3.2,0,0,0-.62.46,3.1,3.1,0,0,0-.55.7,4.18,4.18,0,0,0-.43,1,5.5,5.5,0,0,0-.22,1.32c0,.13,0,.28,0,.47s0,.38,0,.59,0,.39,0,.58,0,.34,0,.44a3,3,0,0,0,.22,1.07,1,1,0,0,0,.43.5.74.74,0,0,0,.55.06,2.44,2.44,0,0,0,.62-.25,3.68,3.68,0,0,0,.62-.46,3.34,3.34,0,0,0,.55-.7,4.85,4.85,0,0,0,.43-1,5.68,5.68,0,0,0,.22-1.32c0-.11,0-.27,0-.46v-1.17C220.12,258.54,220.12,258.39,220.11,258.27Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "218.29px 260.36px"
    },
    id: "ellojugxo6n7i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.13,258.34a1.19,1.19,0,0,1-.12.51.8.8,0,0,1-.29.35l-1.14.66a.24.24,0,0,1-.29,0,.5.5,0,0,1-.12-.37v-5.88a3.51,3.51,0,0,0-.42-2q-.42-.59-1.29-.09a3.15,3.15,0,0,0-1.26,1.56,6.5,6.5,0,0,0-.46,2.49v5.88a1.11,1.11,0,0,1-.12.5.69.69,0,0,1-.28.35l-1.14.66a.21.21,0,0,1-.29,0,.48.48,0,0,1-.12-.37V251.79a1.19,1.19,0,0,1,.12-.51.75.75,0,0,1,.29-.35l1.14-.66a.21.21,0,0,1,.28,0,.5.5,0,0,1,.12.37v.53a8.54,8.54,0,0,1,.92-1.52,4.12,4.12,0,0,1,1.25-1.11,2.53,2.53,0,0,1,1.53-.45,1.42,1.42,0,0,1,1,.61,3.52,3.52,0,0,1,.54,1.41,12,12,0,0,1,.16,2Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "227.464px 255.553px"
    },
    id: "el20vs4dw3s8x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.73,252a13.31,13.31,0,0,1,.26-2.59,12.18,12.18,0,0,1,.74-2.42,9.11,9.11,0,0,1,1.16-2,5.31,5.31,0,0,1,1.53-1.37,2.54,2.54,0,0,1,1.52-.4,1.8,1.8,0,0,1,1.17.6,3.61,3.61,0,0,1,.74,1.44,7.57,7.57,0,0,1,.26,2.11v1a1.19,1.19,0,0,1-.12.51.79.79,0,0,1-.28.35l-5,2.9a2.21,2.21,0,0,0,.14.85.89.89,0,0,0,.38.46.87.87,0,0,0,.56.1,1.78,1.78,0,0,0,.65-.24,3.09,3.09,0,0,0,.78-.6,3.37,3.37,0,0,0,.49-.67,4.89,4.89,0,0,1,.27-.41,1.18,1.18,0,0,1,.29-.23l1.2-.7a.25.25,0,0,1,.3,0,.46.46,0,0,1,.11.38,4,4,0,0,1-.23,1,7.7,7.7,0,0,1-.66,1.37,9.38,9.38,0,0,1-1.07,1.46,5.91,5.91,0,0,1-1.48,1.2,2.69,2.69,0,0,1-1.53.43,1.67,1.67,0,0,1-1.16-.61,3.8,3.8,0,0,1-.74-1.55A9.81,9.81,0,0,1,232.73,252Zm3.69-5.6a2.86,2.86,0,0,0-.75.63,4.3,4.3,0,0,0-.52.81,4.9,4.9,0,0,0-.32.88,5.75,5.75,0,0,0-.14.81l3.39-2a4.07,4.07,0,0,0-.11-.67,1.15,1.15,0,0,0-.27-.54.75.75,0,0,0-.49-.22A1.57,1.57,0,0,0,236.42,246.42Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "236.421px 249.873px"
    },
    id: "elmkkxm4mktyp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,246.93a.5.5,0,0,0-.11-.36.47.47,0,0,0-.37-.09,3.54,3.54,0,0,0-.7.13l-1.11.27a2.48,2.48,0,0,1-1.1.05,1.26,1.26,0,0,1-.7-.4,1.91,1.91,0,0,1-.36-.84,6.38,6.38,0,0,1-.11-1.23,5.74,5.74,0,0,1,.21-1.48,7.56,7.56,0,0,1,.61-1.55,7.78,7.78,0,0,1,1-1.4,5,5,0,0,1,1.31-1.08,4,4,0,0,1,1.31-.51,1.84,1.84,0,0,1,1,.11,1.33,1.33,0,0,1,.63.59,2.27,2.27,0,0,1,.25,1,.93.93,0,0,1-.11.5.75.75,0,0,1-.29.35l-1.16.67c-.15.09-.26.11-.34.07l-.25-.15a.74.74,0,0,0-.36-.08,1.66,1.66,0,0,0-.67.27,3,3,0,0,0-.8.66,1.45,1.45,0,0,0-.35,1,.69.69,0,0,0,.09.38.38.38,0,0,0,.31.13,3.28,3.28,0,0,0,.65-.09c.28-.06.63-.14,1.07-.26.9-.22,1.52-.13,1.89.29a3,3,0,0,1,.55,2,5.45,5.45,0,0,1-.23,1.48,7,7,0,0,1-.65,1.56,8,8,0,0,1-1.05,1.44,6,6,0,0,1-1.41,1.12,3.78,3.78,0,0,1-1.4.53,1.86,1.86,0,0,1-1-.16,1.51,1.51,0,0,1-.65-.67,2.34,2.34,0,0,1-.24-1,1,1,0,0,1,.11-.5.93.93,0,0,1,.3-.36l1.15-.66c.15-.09.27-.1.34,0l.26.23a.66.66,0,0,0,.4.14,1.65,1.65,0,0,0,.76-.28,5.62,5.62,0,0,0,.47-.32,2.85,2.85,0,0,0,.44-.41,1.94,1.94,0,0,0,.34-.47A1.08,1.08,0,0,0,246,246.93Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "244.68px 245.219px"
    },
    id: "elrq1ejnsoxzf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.51,291a3.79,3.79,0,0,1-.1.79,3.08,3.08,0,0,1-.23.63,2.39,2.39,0,0,1-.33.48,1.66,1.66,0,0,1-.39.32.88.88,0,0,1-.53.15.55.55,0,0,1-.32-.17l-.12.29a1.4,1.4,0,0,1-.16.29,1.68,1.68,0,0,1-.25.29,2.19,2.19,0,0,1-.39.28.77.77,0,0,1-.52.12.57.57,0,0,1-.36-.28,1.92,1.92,0,0,1-.22-.59,5.15,5.15,0,0,1-.07-.83,7,7,0,0,1,.07-.92,5,5,0,0,1,.22-.85,3.2,3.2,0,0,1,.36-.69,1.57,1.57,0,0,1,.52-.48c.2-.12.36-.16.47-.11a.69.69,0,0,1,.25.17v-.1a.53.53,0,0,1,.06-.24.35.35,0,0,1,.14-.17l.22-.13c.06,0,.1,0,.14,0a.21.21,0,0,1,.06.17v2.36a.86.86,0,0,0,.11.5c.08.1.18.11.32,0a.58.58,0,0,0,.21-.2,1.3,1.3,0,0,0,.14-.26,1.63,1.63,0,0,0,.07-.3,1.24,1.24,0,0,0,0-.27c0-.09,0-.26,0-.52a7.66,7.66,0,0,0,0-.82c-.06-.87-.26-1.41-.62-1.63s-.84-.16-1.47.21a2.78,2.78,0,0,0-.7.56,4.12,4.12,0,0,0-.61.84,5.3,5.3,0,0,0-.44,1.08,6.22,6.22,0,0,0-.21,1.28c0,.1,0,.23,0,.39s0,.33,0,.51,0,.34,0,.5a3.84,3.84,0,0,0,0,.39,3.26,3.26,0,0,0,.21,1,1.23,1.23,0,0,0,.44.56.91.91,0,0,0,.61.14,1.77,1.77,0,0,0,.7-.24l.5-.33a4.29,4.29,0,0,0,.38-.33q.17-.18.3-.36c.09-.13.18-.27.26-.41l.13-.2a.3.3,0,0,1,.13-.12l.31-.18a.12.12,0,0,1,.14,0,.25.25,0,0,1,.06.2.49.49,0,0,1-.05.19,6.88,6.88,0,0,1-.35.65,5.75,5.75,0,0,1-.46.64,4.76,4.76,0,0,1-.59.6,6.41,6.41,0,0,1-.76.54,2.31,2.31,0,0,1-.94.31,1.22,1.22,0,0,1-.8-.21,1.68,1.68,0,0,1-.58-.75,3.79,3.79,0,0,1-.26-1.31c0-.1,0-.24,0-.41s0-.35,0-.54,0-.37,0-.54,0-.31,0-.4a6.61,6.61,0,0,1,.26-1.61,6.69,6.69,0,0,1,.57-1.42,6,6,0,0,1,.8-1.15,4,4,0,0,1,.95-.78,2.92,2.92,0,0,1,1.09-.4,1.21,1.21,0,0,1,.83.19,1.48,1.48,0,0,1,.55.77,4.37,4.37,0,0,1,.23,1.34c0,.15,0,.3,0,.45a3.08,3.08,0,0,1,0,.43v.36C196.51,290.85,196.51,290.92,196.51,291Zm-3.37,1.41a3.4,3.4,0,0,0,0,.45,1.31,1.31,0,0,0,.11.38.44.44,0,0,0,.19.21.31.31,0,0,0,.3,0,1.13,1.13,0,0,0,.51-.66,3.8,3.8,0,0,0,.13-1.08,4.16,4.16,0,0,0,0-.54,1,1,0,0,0-.1-.37.3.3,0,0,0-.2-.17.4.4,0,0,0-.31.08.86.86,0,0,0-.3.3,1.77,1.77,0,0,0-.19.44,2.78,2.78,0,0,0-.11.5A4.46,4.46,0,0,0,193.14,292.37Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "193.86px 291.937px"
    },
    id: "elau42gygxa3b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.23,291.58a3,3,0,0,1,.12-.85,3.53,3.53,0,0,1,.32-.75,3.63,3.63,0,0,1,.47-.64,6,6,0,0,1,.57-.56l1-.84v-.14c0-.38-.08-.62-.25-.71a.56.56,0,0,0-.6.06,1.33,1.33,0,0,0-.48.46,3.43,3.43,0,0,0-.27.58.55.55,0,0,1-.1.17.5.5,0,0,1-.13.12l-.22.12a.11.11,0,0,1-.14,0,.19.19,0,0,1,0-.18,2.43,2.43,0,0,1,.12-.57,4.5,4.5,0,0,1,.3-.63,4.92,4.92,0,0,1,.44-.58,2.57,2.57,0,0,1,.53-.43,1.33,1.33,0,0,1,.6-.2.66.66,0,0,1,.48.14,1.06,1.06,0,0,1,.31.51,3,3,0,0,1,.11.88v3.38a.61.61,0,0,1-.06.25.31.31,0,0,1-.13.16l-.27.16a.12.12,0,0,1-.14,0,.3.3,0,0,1-.05-.18v-.45a2,2,0,0,1-.21.48,3.37,3.37,0,0,1-.31.46,3.23,3.23,0,0,1-.37.37,1.94,1.94,0,0,1-.35.27,1.32,1.32,0,0,1-.52.17.56.56,0,0,1-.39-.1.69.69,0,0,1-.26-.35A1.53,1.53,0,0,1,197.23,291.58Zm1.33-.16a1.76,1.76,0,0,0,.47-.4,2.44,2.44,0,0,0,.38-.55,2.78,2.78,0,0,0,.23-.65,2.82,2.82,0,0,0,.09-.71v-.28l-.85.7a3.4,3.4,0,0,0-.72.77,1.42,1.42,0,0,0-.27.79.54.54,0,0,0,0,.22.39.39,0,0,0,.11.17.28.28,0,0,0,.21,0A.72.72,0,0,0,198.56,291.42Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "198.82px 289.31px"
    },
    id: "elyxj1uqmythh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,288.92c.06,0,.1,0,.14,0a.24.24,0,0,1,.06.18v.74a.61.61,0,0,1-.06.25.32.32,0,0,1-.14.16l-.48.28a.11.11,0,0,1-.14,0,.28.28,0,0,1-.05-.18v-.74a.69.69,0,0,1,.05-.24.41.41,0,0,1,.14-.17Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "201.765px 289.738px"
    },
    id: "el7ido4dr5fd3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.19,284.12a.53.53,0,0,1,.06-.24.35.35,0,0,1,.14-.17l.26-.15a.11.11,0,0,1,.14,0,.21.21,0,0,1,.06.17v5.64a4.2,4.2,0,0,1-.28,1.6,2.1,2.1,0,0,1-.91,1l-.14.08a.11.11,0,0,1-.14,0,.25.25,0,0,1,0-.17v-.36a.69.69,0,0,1,0-.24.41.41,0,0,1,.14-.17l.07,0a1.05,1.05,0,0,0,.3-.25,1.08,1.08,0,0,0,.19-.31,1.82,1.82,0,0,0,.09-.37c0-.13,0-.26,0-.4Zm.73-1.89a.53.53,0,0,1-.06.24.35.35,0,0,1-.14.17l-.41.24a.1.1,0,0,1-.13,0,.24.24,0,0,1-.06-.18v-.63a.57.57,0,0,1,.06-.25.48.48,0,0,1,.13-.17l.41-.23c.06,0,.1,0,.14,0a.21.21,0,0,1,.06.17Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "203.143px 286.748px"
    },
    id: "el3sa7kthv9i9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.46,281.82a1.29,1.29,0,0,1,.69-.21.75.75,0,0,1,.52.2,1.25,1.25,0,0,1,.34.59,3.37,3.37,0,0,1,.16.91c0,.06,0,.14,0,.24v.57c0,.09,0,.17,0,.23a7.46,7.46,0,0,1-.16,1.1,4.19,4.19,0,0,1-.34,1,3.93,3.93,0,0,1-.52.8,2.54,2.54,0,0,1-.69.58,1.41,1.41,0,0,1-.69.22.76.76,0,0,1-.52-.21,1.29,1.29,0,0,1-.34-.58,3.72,3.72,0,0,1-.16-.91,2.11,2.11,0,0,0,0-.23v-.57a2.36,2.36,0,0,0,0-.25,6.66,6.66,0,0,1,.16-1.09,4.71,4.71,0,0,1,.34-1,3.45,3.45,0,0,1,.52-.8A2.58,2.58,0,0,1,206.46,281.82Zm1,2.86c0-.13,0-.29,0-.47s0-.34,0-.46a2.27,2.27,0,0,0-.09-.57,1,1,0,0,0-.2-.38.44.44,0,0,0-.32-.15.77.77,0,0,0-.44.13,1.55,1.55,0,0,0-.44.37,2.47,2.47,0,0,0-.31.52,2.92,2.92,0,0,0-.21.61,5.06,5.06,0,0,0-.09.68c0,.14,0,.3,0,.48s0,.33,0,.45a3,3,0,0,0,.09.57.92.92,0,0,0,.21.38.46.46,0,0,0,.31.15.75.75,0,0,0,.44-.13,1.46,1.46,0,0,0,.44-.38,2.2,2.2,0,0,0,.32-.51,3.72,3.72,0,0,0,.29-1.29Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "206.46px 284.83px"
    },
    id: "el9399nc8x5o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.41,284a.53.53,0,0,1-.06.24.4.4,0,0,1-.13.17l-.27.15a.11.11,0,0,1-.14,0,.21.21,0,0,1-.06-.17v-2.93a1.63,1.63,0,0,0-.26-1.12c-.18-.18-.43-.18-.74,0a1.82,1.82,0,0,0-.73.85,3.2,3.2,0,0,0-.28,1.43v2.93a.53.53,0,0,1-.06.24.31.31,0,0,1-.14.17l-.26.16a.12.12,0,0,1-.14,0,.24.24,0,0,1-.06-.18v-5.17a.53.53,0,0,1,.06-.24.35.35,0,0,1,.14-.17l.26-.16a.12.12,0,0,1,.14,0,.24.24,0,0,1,.06.18v.35a3.51,3.51,0,0,1,.41-.75,2.08,2.08,0,0,1,.7-.65,1.19,1.19,0,0,1,.63-.19.68.68,0,0,1,.49.2,1.31,1.31,0,0,1,.33.6,3.81,3.81,0,0,1,.11,1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "210.745px 282.641px"
    },
    id: "elj7xedi9kw8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.28,280.33a5.45,5.45,0,0,1,.16-1.05,5.54,5.54,0,0,1,.34-1,4.09,4.09,0,0,1,.5-.81,2.32,2.32,0,0,1,.65-.57,1.2,1.2,0,0,1,.7-.2.74.74,0,0,1,.52.25,1.76,1.76,0,0,1,.33.7,4.39,4.39,0,0,1,.11,1.1v.3a.52.52,0,0,1-.05.24.41.41,0,0,1-.14.17l-2.48,1.43V281a1.31,1.31,0,0,0,.3,1,.58.58,0,0,0,.71,0,1.83,1.83,0,0,0,.6-.52,4.66,4.66,0,0,0,.32-.56.47.47,0,0,1,.1-.18.36.36,0,0,1,.13-.11l.21-.13a.12.12,0,0,1,.15,0,.19.19,0,0,1,.05.18,2.72,2.72,0,0,1-.13.51,2.59,2.59,0,0,1-.29.61,3.27,3.27,0,0,1-.47.62,2.92,2.92,0,0,1-.67.52,1.08,1.08,0,0,1-.65.18.81.81,0,0,1-.5-.24,1.63,1.63,0,0,1-.34-.6,3.37,3.37,0,0,1-.16-.91A8.68,8.68,0,0,1,213.28,280.33Zm.64-.34,2-1.17v0a1.22,1.22,0,0,0-.28-.92c-.18-.17-.43-.16-.74,0a1.49,1.49,0,0,0-.39.33,2.33,2.33,0,0,0-.31.48,2.25,2.25,0,0,0-.22.6,3.5,3.5,0,0,0-.09.66Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "214.928px 279.91px"
    },
    id: "elq9lnavbbnw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.6,278.52a.52.52,0,0,0-.08-.31.27.27,0,0,0-.22-.1,1.43,1.43,0,0,0-.39,0,5.18,5.18,0,0,0-.54.13c-.39.09-.66,0-.82-.16a1.41,1.41,0,0,1-.23-.89,2.68,2.68,0,0,1,.08-.68,3.52,3.52,0,0,1,.26-.68,2.79,2.79,0,0,1,1.05-1.11,1.59,1.59,0,0,1,.62-.23.88.88,0,0,1,.44.05.68.68,0,0,1,.28.25.88.88,0,0,1,.1.36.6.6,0,0,1-.06.24.41.41,0,0,1-.14.17l-.24.13a.23.23,0,0,1-.1,0,.13.13,0,0,1-.11-.07.36.36,0,0,0-.28-.15.91.91,0,0,0-.51.16,1.59,1.59,0,0,0-.53.5,1.13,1.13,0,0,0-.21.64.63.63,0,0,0,.06.31.25.25,0,0,0,.19.11,1,1,0,0,0,.34,0l.53-.12a1.2,1.2,0,0,1,.55,0,.68.68,0,0,1,.36.18.77.77,0,0,1,.2.37,2.59,2.59,0,0,1,.05.51,2.52,2.52,0,0,1-.1.7,3.23,3.23,0,0,1-.3.72,3.7,3.7,0,0,1-.47.65,3.06,3.06,0,0,1-.63.51,1.81,1.81,0,0,1-.63.23,1.14,1.14,0,0,1-.47-.06.62.62,0,0,1-.3-.25.89.89,0,0,1-.11-.36.69.69,0,0,1,0-.24.36.36,0,0,1,.15-.17l.26-.15.1,0s.07,0,.11.06a.41.41,0,0,0,.31.2,1,1,0,0,0,.53-.18,1.55,1.55,0,0,0,.31-.23,1.72,1.72,0,0,0,.47-.66A.91.91,0,0,0,219.6,278.52Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "218.74px 277.713px"
    },
    id: "elio80jsc7val",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.79,346.52a.53.53,0,0,1,.08-.26.39.39,0,0,1,.13-.15l.58-.33c.06,0,.1,0,.14,0a.22.22,0,0,1,.06.18,6.56,6.56,0,0,1-.15,1,4.25,4.25,0,0,1-.39,1,5,5,0,0,1-.65,1,3.86,3.86,0,0,1-1,.78,1.69,1.69,0,0,1-.88.28,1,1,0,0,1-.65-.25,1.79,1.79,0,0,1-.41-.74,4.46,4.46,0,0,1-.18-1.13c0-.27,0-.58,0-.92s0-.65,0-.94a7.34,7.34,0,0,1,.18-1.33,6.14,6.14,0,0,1,.41-1.21,5,5,0,0,1,.65-1,3.6,3.6,0,0,1,.88-.73,1.93,1.93,0,0,1,1-.32,1,1,0,0,1,.65.22,1.17,1.17,0,0,1,.39.6,3.61,3.61,0,0,1,.15.82.54.54,0,0,1-.06.25.32.32,0,0,1-.14.16l-.58.34a.14.14,0,0,1-.14,0,.23.23,0,0,1-.08-.17.93.93,0,0,0-.1-.38.58.58,0,0,0-.21-.25.57.57,0,0,0-.35-.07,1.3,1.3,0,0,0-.49.17,1.79,1.79,0,0,0-.49.42,2.3,2.3,0,0,0-.35.56,3.3,3.3,0,0,0-.21.65,3.54,3.54,0,0,0-.09.71c0,.29,0,.6,0,.94s0,.65,0,.92a2.18,2.18,0,0,0,.09.61.89.89,0,0,0,.21.4.5.5,0,0,0,.35.16.88.88,0,0,0,.49-.15,2.11,2.11,0,0,0,.49-.39,2.49,2.49,0,0,0,.35-.47,2.81,2.81,0,0,0,.22-.51A2.25,2.25,0,0,0,126.79,346.52Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "125.626px 345.735px"
    },
    id: "el8c7dtlxfeb6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,344.6a.1.1,0,0,1,.13,0,.24.24,0,0,1,.06.18v.79a.53.53,0,0,1-.06.24.34.34,0,0,1-.13.17l-3.17,1.82a.09.09,0,0,1-.13,0,.21.21,0,0,1-.06-.17v-7.17a.53.53,0,0,1,.06-.24.4.4,0,0,1,.13-.17l3.11-1.79a.11.11,0,0,1,.14,0,.26.26,0,0,1,.05.18v.78a.74.74,0,0,1-.05.25.38.38,0,0,1-.14.16L129.59,341v1.76l2.17-1.25a.11.11,0,0,1,.14,0,.24.24,0,0,1,.06.18v.78a.54.54,0,0,1-.06.25.41.41,0,0,1-.14.17l-2.17,1.25V346Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "130.415px 343.031px"
    },
    id: "elmpyf1wtls2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.85,340.62a6.67,6.67,0,0,1,.15-1.26,5.63,5.63,0,0,1,.39-1.18,4.91,4.91,0,0,1,.65-1,3.3,3.3,0,0,1,.93-.77,1.9,1.9,0,0,1,.91-.3.94.94,0,0,1,.65.27,1.75,1.75,0,0,1,.39.73,3.84,3.84,0,0,1,.16,1.08c0,.14,0,.29,0,.46s0,.35,0,.53,0,.35,0,.52,0,.33,0,.48a6.77,6.77,0,0,1-.15,1.26,5.83,5.83,0,0,1-.39,1.18,4.51,4.51,0,0,1-.66,1,3.32,3.32,0,0,1-.91.76,1.79,1.79,0,0,1-.93.3.91.91,0,0,1-.65-.26,1.63,1.63,0,0,1-.39-.73,4.26,4.26,0,0,1-.15-1.08c0-.13,0-.29,0-.46s0-.34,0-.52,0-.36,0-.53S132.84,340.76,132.85,340.62Zm3.26-1.83a1.43,1.43,0,0,0-.33-1q-.32-.27-.81,0a2.06,2.06,0,0,0-.82.9,3.54,3.54,0,0,0-.33,1.43c0,.29,0,.6,0,.95s0,.65,0,.93a1.41,1.41,0,0,0,.33,1,.69.69,0,0,0,.82,0,2.23,2.23,0,0,0,.81-.9,3.5,3.5,0,0,0,.33-1.43c0-.28,0-.6,0-.94S136.12,339.06,136.11,338.79Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "134.963px 340.395px"
    },
    id: "el65li94o1v0b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.34,333.63,140,335a.1.1,0,0,1-.13,0,.24.24,0,0,1-.06-.18V334a.53.53,0,0,1,.06-.24.34.34,0,0,1,.13-.17l3.14-1.81c.06,0,.1,0,.14,0a.21.21,0,0,1,.06.17v4.69a5.45,5.45,0,0,1-.52,2.46,3.73,3.73,0,0,1-1.49,1.58,2,2,0,0,1-.88.32.92.92,0,0,1-.61-.17,1.17,1.17,0,0,1-.36-.57,3.15,3.15,0,0,1-.15-.87.54.54,0,0,1,.06-.25.32.32,0,0,1,.14-.16l.58-.34a.13.13,0,0,1,.12,0s.06,0,.07.11a1.34,1.34,0,0,0,.11.37.52.52,0,0,0,.19.26.43.43,0,0,0,.3.08,1,1,0,0,0,.43-.15,1.85,1.85,0,0,0,.77-.84,3,3,0,0,0,.27-1.32Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "141.336px 336.391px"
    },
    id: "elegm2kvbngdg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,332a1.37,1.37,0,0,1,.72-.23.85.85,0,0,1,.55.2,1.28,1.28,0,0,1,.37.56,2.68,2.68,0,0,1,.17.86v1.12a5.47,5.47,0,0,1-.17,1,4.69,4.69,0,0,1-.37,1,4.78,4.78,0,0,1-.55.83,3.16,3.16,0,0,1-.72.61,1.48,1.48,0,0,1-.72.22.87.87,0,0,1-.55-.19,1.28,1.28,0,0,1-.37-.56,2.68,2.68,0,0,1-.17-.86c0-.06,0-.14,0-.24v-.62c0-.1,0-.19,0-.26a5.45,5.45,0,0,1,.16-1.05,5.34,5.34,0,0,1,.38-1,4.06,4.06,0,0,1,.55-.84A2.71,2.71,0,0,1,146,332Zm.87,2a1.52,1.52,0,0,0-.1-.51.51.51,0,0,0-.21-.24.32.32,0,0,0-.27,0,1,1,0,0,0-.29.12,1.91,1.91,0,0,0-.3.22,1.81,1.81,0,0,0-.26.33,2.67,2.67,0,0,0-.21.48,3,3,0,0,0-.1.63,1.62,1.62,0,0,0,0,.23,2.62,2.62,0,0,0,0,.28,2.53,2.53,0,0,0,0,.28,1.22,1.22,0,0,0,0,.21,1.52,1.52,0,0,0,.1.51.6.6,0,0,0,.21.25.39.39,0,0,0,.26,0,1.3,1.3,0,0,0,.3-.13,1.17,1.17,0,0,0,.29-.22,1.49,1.49,0,0,0,.27-.33,2.67,2.67,0,0,0,.21-.48,3,3,0,0,0,.1-.63,1.41,1.41,0,0,0,0-.22v-.56A1.35,1.35,0,0,0,146.85,334Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "146px 334.97px"
    },
    id: "el2jp2ic9rsoo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.13,334.05a.57.57,0,0,1-.06.25.36.36,0,0,1-.13.16l-.55.32a.11.11,0,0,1-.14,0,.24.24,0,0,1-.06-.18v-2.81a1.64,1.64,0,0,0-.2-.95c-.13-.19-.34-.2-.62,0a1.47,1.47,0,0,0-.6.74,3.19,3.19,0,0,0-.22,1.19v2.82a.61.61,0,0,1-.06.25.31.31,0,0,1-.13.16l-.55.32a.11.11,0,0,1-.14,0,.24.24,0,0,1,0-.18v-5.17a.52.52,0,0,1,0-.24.41.41,0,0,1,.14-.17l.55-.31a.09.09,0,0,1,.13,0,.21.21,0,0,1,.06.17v.26a4,4,0,0,1,.44-.73,2.2,2.2,0,0,1,.6-.54,1.24,1.24,0,0,1,.73-.21.68.68,0,0,1,.48.29,1.86,1.86,0,0,1,.26.68,5.57,5.57,0,0,1,.07.95Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "150.391px 332.772px"
    },
    id: "elzy73vgsiih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.9,331a6.59,6.59,0,0,1,.12-1.24,5.73,5.73,0,0,1,.36-1.15,4.46,4.46,0,0,1,.55-1,2.54,2.54,0,0,1,.74-.66,1.19,1.19,0,0,1,.73-.19.89.89,0,0,1,.56.28,1.7,1.7,0,0,1,.35.7,3.44,3.44,0,0,1,.13,1v.49a.54.54,0,0,1-.06.25.4.4,0,0,1-.14.17l-2.4,1.38a.94.94,0,0,0,.07.41.37.37,0,0,0,.18.22.41.41,0,0,0,.27,0,.83.83,0,0,0,.31-.11,1.9,1.9,0,0,0,.37-.29,1.41,1.41,0,0,0,.24-.32,1,1,0,0,1,.13-.2.4.4,0,0,1,.14-.11l.57-.33a.11.11,0,0,1,.14,0,.21.21,0,0,1,.06.17,2.14,2.14,0,0,1-.12.47,3.81,3.81,0,0,1-.31.66,5.09,5.09,0,0,1-.51.69,3.06,3.06,0,0,1-.71.58,1.31,1.31,0,0,1-.74.2.76.76,0,0,1-.55-.29,1.83,1.83,0,0,1-.36-.74A4.78,4.78,0,0,1,152.9,331Zm1.77-2.68a1.31,1.31,0,0,0-.36.3,2,2,0,0,0-.25.39,1.77,1.77,0,0,0-.15.42,2,2,0,0,0-.07.39l1.63-.94a2,2,0,0,0-.06-.32.58.58,0,0,0-.13-.26.33.33,0,0,0-.24-.1A.65.65,0,0,0,154.67,328.34Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "154.67px 329.914px"
    },
    id: "elz6bwneh2sqk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.26,328.58a.25.25,0,0,0,0-.17.25.25,0,0,0-.17,0,1.28,1.28,0,0,0-.34.06l-.53.13a1.24,1.24,0,0,1-.53,0,.56.56,0,0,1-.33-.2.78.78,0,0,1-.18-.4,3.42,3.42,0,0,1,0-.59,2.64,2.64,0,0,1,.1-.71,3.55,3.55,0,0,1,.29-.74,3.38,3.38,0,0,1,.47-.67,2.56,2.56,0,0,1,.62-.52,1.67,1.67,0,0,1,.63-.24.82.82,0,0,1,.48.05.67.67,0,0,1,.3.28,1.16,1.16,0,0,1,.12.46.42.42,0,0,1-.05.24.35.35,0,0,1-.14.17l-.56.32c-.07,0-.13,0-.16,0l-.12-.07a.29.29,0,0,0-.17,0,.83.83,0,0,0-.33.12,1.44,1.44,0,0,0-.38.32.67.67,0,0,0-.16.45.42.42,0,0,0,0,.18.19.19,0,0,0,.16.07l.31,0,.51-.13c.43-.1.73-.06.91.14a1.47,1.47,0,0,1,.26,1,2.67,2.67,0,0,1-.11.71,3.42,3.42,0,0,1-.82,1.44,2.89,2.89,0,0,1-.67.54,1.73,1.73,0,0,1-.68.25.86.86,0,0,1-.49-.08.69.69,0,0,1-.31-.32,1,1,0,0,1-.11-.47.47.47,0,0,1,.05-.25.41.41,0,0,1,.14-.17l.56-.32c.07,0,.12,0,.16,0l.12.11a.36.36,0,0,0,.19.06.74.74,0,0,0,.37-.13,1.43,1.43,0,0,0,.22-.15,2.09,2.09,0,0,0,.22-.2,1.34,1.34,0,0,0,.16-.23A.5.5,0,0,0,159.26,328.58Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "158.678px 327.796px"
    },
    id: "elrtasdmez5ms",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.87,328.15a.11.11,0,0,1-.14,0s0-.09,0-.18V320.8a.52.52,0,0,1,0-.24.41.41,0,0,1,.14-.17l.58-.34c.06,0,.1,0,.14,0a.24.24,0,0,1,.06.18v7.16a.57.57,0,0,1-.06.25.4.4,0,0,1-.14.17Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "163.183px 324.113px"
    },
    id: "el3on1poqknld",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.22,324.76a.61.61,0,0,1-.06.25.31.31,0,0,1-.13.16l-.55.32a.11.11,0,0,1-.14,0,.3.3,0,0,1-.05-.18v-2.81a1.63,1.63,0,0,0-.21-.95c-.13-.19-.34-.2-.61,0a1.44,1.44,0,0,0-.61.74,3.19,3.19,0,0,0-.22,1.19v2.82a.79.79,0,0,1,0,.25.38.38,0,0,1-.14.16l-.55.32a.09.09,0,0,1-.13,0,.24.24,0,0,1-.06-.18v-5.17a.53.53,0,0,1,.06-.24.34.34,0,0,1,.13-.17l.55-.31a.11.11,0,0,1,.14,0,.25.25,0,0,1,0,.17v.26a4,4,0,0,1,.44-.73,2.2,2.2,0,0,1,.6-.54,1.19,1.19,0,0,1,.74-.21.68.68,0,0,1,.47.29,1.7,1.7,0,0,1,.26.68,5.57,5.57,0,0,1,.07.95Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "166.49px 323.483px"
    },
    id: "elk51uhok9s3m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.94,320.8c0,.12,0,.25,0,.4s0,.27,0,.38a1.51,1.51,0,0,0,.1.53.61.61,0,0,0,.2.28.44.44,0,0,0,.26.07.72.72,0,0,0,.29-.1,1.54,1.54,0,0,0,.31-.22,1.64,1.64,0,0,0,.21-.25c.05-.09.1-.18.14-.27l.12-.31c0-.08.06-.17.1-.26a.39.39,0,0,1,.14-.18l.55-.31a.12.12,0,0,1,.14,0,.21.21,0,0,1,.05.18,2.6,2.6,0,0,1-.11.63,3.79,3.79,0,0,1-.31.82,4.52,4.52,0,0,1-.54.83,2.89,2.89,0,0,1-.8.67,1.23,1.23,0,0,1-.71.2.88.88,0,0,1-.55-.23,1.37,1.37,0,0,1-.37-.6,3.21,3.21,0,0,1-.16-.88c0-.12,0-.27,0-.43s0-.32,0-.46a5.77,5.77,0,0,1,.16-1.07,4.84,4.84,0,0,1,.37-1,3.89,3.89,0,0,1,.55-.87,2.58,2.58,0,0,1,.71-.62,1.52,1.52,0,0,1,.8-.25.93.93,0,0,1,.54.2,1.11,1.11,0,0,1,.31.46,1.42,1.42,0,0,1,.11.5.47.47,0,0,1-.05.25.41.41,0,0,1-.14.17l-.55.31a.1.1,0,0,1-.14,0,.71.71,0,0,1-.1-.14,1.25,1.25,0,0,0-.12-.17.33.33,0,0,0-.14-.1.3.3,0,0,0-.21,0,1.22,1.22,0,0,0-.31.13,1.28,1.28,0,0,0-.29.24,1.5,1.5,0,0,0-.26.38,2.09,2.09,0,0,0-.2.5A2.6,2.6,0,0,0,169.94,320.8Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "170.777px 320.685px"
    },
    id: "elah3i6sb42q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.11,320a.12.12,0,0,1,.14,0,.24.24,0,0,1,.06.18v1.09a.53.53,0,0,1-.06.24.35.35,0,0,1-.14.17l-.67.39a.1.1,0,0,1-.13,0,.24.24,0,0,1-.06-.18v-1.09a.53.53,0,0,1,.06-.24.4.4,0,0,1,.13-.17Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "173.78px 321.036px"
    },
    id: "el309wtxxyd2k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.13,364.18a.75.75,0,0,1-.65-.37.75.75,0,0,1,.28-1l97.6-56.35a.75.75,0,0,1,1,.27.76.76,0,0,1-.28,1l-97.6,56.35A.75.75,0,0,1,123.13,364.18Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "171.918px 335.274px"
    },
    id: "elwn0ehnar3j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.13,372.85a.75.75,0,0,1-.65-.37.75.75,0,0,1,.28-1l97.6-56.35a.75.75,0,0,1,1,.27.76.76,0,0,1-.28,1l-97.6,56.35A.75.75,0,0,1,123.13,372.85Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "171.918px 343.944px"
    },
    id: "elq1z0rj2x93",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.13,381.52a.75.75,0,0,1-.65-.37.75.75,0,0,1,.28-1l78.83-45.52a.76.76,0,0,1,1,.28.75.75,0,0,1-.28,1l-78.83,45.52A.75.75,0,0,1,123.13,381.52Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "162.535px 358.032px"
    },
    id: "eluztj7a6pwml",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.13,391a.75.75,0,0,1-.65-.37.75.75,0,0,1,.28-1l97.6-56.35a.75.75,0,1,1,.75,1.3l-97.6,56.35A.75.75,0,0,1,123.13,391Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "171.939px 362.09px"
    },
    id: "elvvop4054v5i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.13,399.63a.75.75,0,0,1-.65-.37.75.75,0,0,1,.28-1l97.6-56.35a.75.75,0,0,1,1,.27.76.76,0,0,1-.28,1l-97.6,56.35A.75.75,0,0,1,123.13,399.63Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "171.918px 370.724px"
    },
    id: "elvwhx5w7kys9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.13,408.3a.75.75,0,0,1-.65-.37.75.75,0,0,1,.28-1l97.6-56.35a.75.75,0,0,1,1,.27.76.76,0,0,1-.28,1l-97.6,56.35A.75.75,0,0,1,123.13,408.3Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "171.918px 379.394px"
    },
    id: "elec4vj1un9ti",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.13,417.74a.75.75,0,0,1-.65-.37.75.75,0,0,1,.28-1l53.89-31.11a.75.75,0,0,1,1,.27.76.76,0,0,1-.28,1l-53.89,31.11A.75.75,0,0,1,123.13,417.74Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "150.063px 401.454px"
    },
    id: "eld84w5fqkl4v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Location--inject-112",
    d: "M236.15,323.2c-1.63.94-3,3.87-3,6.52v.61c0,1.77,1.41,3.77,2.4,5,.32.41.9.07,1.21-.7,1-2.39,2.34-6,2.33-7.76v-.61C239.13,323.63,237.77,322.26,236.15,323.2Zm0,6.9c-.86.5-1.6-.15-1.61-1.47a4.15,4.15,0,0,1,1.58-3.32c.86-.49,1.6.16,1.61,1.48A4.12,4.12,0,0,1,236.19,330.1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "236.12px 329.204px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.9,347.13c.32-.71,1-1.25,1.38-1.17l.39.08c.22,0,.52-.21.69-.58s.12-.7-.09-.74l-.39-.08a1.8,1.8,0,0,0-1.45.55,5.1,5.1,0,0,0-1.3,1.78l-1.95,4.31c-.66,1.46-.5,2.79.36,3l.39.08a1.83,1.83,0,0,0,1.45-.55,5.2,5.2,0,0,0,1.3-1.78l.92-2c.17-.37.13-.7-.09-.74s-.52.21-.68.58l-.92,2c-.32.71-1,1.25-1.38,1.16l-.39-.08c-.43-.09-.51-.75-.18-1.48l1.94-4.31Zm3.33-.77,1.94-4.31a3.79,3.79,0,0,0,.39-2,1,1,0,0,0-.75-1l-.39-.08a1.85,1.85,0,0,0-1.45.55,5.1,5.1,0,0,0-1.3,1.78l-.84,1.86c-.17.37-.13.7.09.75s.52-.22.69-.59l.84-1.86a2.6,2.6,0,0,1,.65-.89.89.89,0,0,1,.73-.27l.38.08a.51.51,0,0,1,.38.5,2,2,0,0,1-.2,1l-1.94,4.31c-.32.71-1,1.25-1.38,1.17-.21-.05-.52.21-.69.58s-.12.7.09.74a1.82,1.82,0,0,0,1.46-.55,5.1,5.1,0,0,0,1.3-1.78Zm0,0",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "236.173px 346.665px"
    },
    id: "elrrot2mc6i6e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,324.31a1.39,1.39,0,0,1-.7-2.59l37.54-21.67a1.39,1.39,0,0,1,1.39,2.4l-37.54,21.67A1.36,1.36,0,0,1,247,324.31Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "265.727px 312.109px"
    },
    id: "el4l0y650qby",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,341.65a1.39,1.39,0,0,1-.7-2.59l37.54-21.67a1.39,1.39,0,0,1,1.39,2.4l-37.54,21.67A1.36,1.36,0,0,1,247,341.65Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "265.727px 329.449px"
    },
    id: "elxnhoh96hdp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.35,292.09v4.09a1.63,1.63,0,0,1-.61,1.31l-7.12,4.11c-.34.19-.62-.07-.62-.6v-4.09l2-1.13v1.67l1.08-.63v-1.67l2.25-1.3v1.68l1.09-.63v-1.68Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "236.175px 296.876px"
    },
    id: "elnpmquwq6wf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.69,288.38l-7,4.05a1.6,1.6,0,0,0-.66,1.26v1.55l8.35-4.82v-1.55C240.35,288.39,240.06,288.17,239.69,288.38Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "236.205px 291.77px"
    },
    id: "el3mpy5gntjxw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.23,288.19l-.56.33v-1.08c0-.09,0-.13-.11-.1l-2.77,1.6a.26.26,0,0,0-.1.22v1.08l-.57.33v-1.08a1.76,1.76,0,0,1,.67-1.42l2.77-1.6c.37-.22.67.07.67.64Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "236.175px 288.483px"
    },
    id: "el11clqkht12hc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.35,309.83v4.09a1.61,1.61,0,0,1-.61,1.3l-7.12,4.11c-.34.2-.62-.07-.62-.59v-4.09l2-1.14v1.67l1.08-.62v-1.68l2.25-1.29v1.67l1.09-.63V311Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "236.175px 314.613px"
    },
    id: "el8unb78y9uin",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.69,306.11l-7,4.06a1.58,1.58,0,0,0-.66,1.26V313l8.35-4.82v-1.54C240.35,306.12,240.06,305.9,239.69,306.11Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "236.205px 309.516px"
    },
    id: "eldlbdx0pqk4v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.23,305.93l-.56.33v-1.08c0-.09,0-.14-.11-.11l-2.77,1.6a.29.29,0,0,0-.1.22V308l-.57.32v-1.08a1.76,1.76,0,0,1,.67-1.42l2.77-1.6c.37-.21.67.08.67.65Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "236.175px 306.236px"
    },
    id: "eleuohsu8ubl9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,289.63a1.39,1.39,0,0,1-.7-2.59l37.54-21.67a1.39,1.39,0,0,1,1.39,2.4l-37.54,21.67A1.36,1.36,0,0,1,247,289.63Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "265.727px 277.429px"
    },
    id: "elo1vdsnokzya",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,307a1.39,1.39,0,0,1-.7-2.59l37.54-21.67a1.39,1.39,0,0,1,1.39,2.4l-37.54,21.67A1.36,1.36,0,0,1,247,307Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "265.727px 294.799px"
    },
    id: "elrovmkjnn6zk",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Buttons--inject-112",
    className: "animable",
    style: {
      transformOrigin: "294.825px 220.335px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-112",
    className: "animable",
    style: {
      transformOrigin: "294.825px 204.577px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--button--inject-112",
    className: "animable",
    style: {
      transformOrigin: "294.825px 204.577px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.13,180.16l-46.46,26.91c-.58.34-1.06,1.16-1.06,2.74V226a2.32,2.32,0,0,0,1.07,2l1.77,1a2.36,2.36,0,0,0,2.12,0L320,202.08a2.36,2.36,0,0,0,1.06-1.83V183a2.29,2.29,0,0,0-1.07-1.82l-1.77-1A2.33,2.33,0,0,0,316.13,180.16Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "294.835px 204.587px"
    },
    id: "ele8bsaicj6eo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1ag2mgv2ske"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.57,229a2.39,2.39,0,0,1-2.12,0l-1.77-1a2.33,2.33,0,0,1-1.07-2V209.81a3.44,3.44,0,0,1,.34-2l3.87,2.24a2.3,2.3,0,0,0-.31,1.25v16.16C272.51,229,273,229.35,273.57,229Z",
    style: {
      opacity: 0.2,
      transformOrigin: "271.075px 218.529px"
    },
    className: "animable",
    id: "elgptfrq93qao"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elbdfj4i90wps"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.07,182.78c-.08-.54-.51-.73-1-.42l-46.46,26.91a2.2,2.2,0,0,0-.75.79l-3.88-2.24a2.1,2.1,0,0,1,.73-.75l46.46-26.92a2.39,2.39,0,0,1,2.12,0l1.77,1A2.29,2.29,0,0,1,321.07,182.78Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "295.025px 194.981px"
    },
    className: "animable",
    id: "elhq6icqfqs9g"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M320,182.36l-46.46,26.91a2.36,2.36,0,0,0-1.06,1.83v17.28c0,.67.48,1,1.06.61L320,202.08a2.36,2.36,0,0,0,1.06-1.83V183C321.09,182.29,320.61,182,320,182.36Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "296.771px 205.681px"
    },
    id: "eluhn5k1ylz5b",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M288.69,206.46a.09.09,0,0,1,.13,0,.22.22,0,0,1,.06.18v1.17a.53.53,0,0,1-.06.24.35.35,0,0,1-.13.17l-2.16,1.25V211l2-1.17a.12.12,0,0,1,.14,0,.24.24,0,0,1,.06.18v1.18a.53.53,0,0,1-.06.24.41.41,0,0,1-.14.17l-2,1.16v2.4a.69.69,0,0,1,0,.24.41.41,0,0,1-.14.17l-.95.54a.09.09,0,0,1-.13,0,.23.23,0,0,1-.06-.18v-7.16a.53.53,0,0,1,.06-.24.35.35,0,0,1,.13-.17Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "287.065px 211.285px"
    },
    id: "el9sae3zvh7ki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.23,208.29c0,.11,0,.25,0,.42s0,.32,0,.44a4.63,4.63,0,0,1-.16,1.09,4.83,4.83,0,0,1-.39,1,4.32,4.32,0,0,1-.61.9,3.13,3.13,0,0,1-.8.66,1.74,1.74,0,0,1-.79.26.92.92,0,0,1-.61-.2,1.31,1.31,0,0,1-.4-.59,2.9,2.9,0,0,1-.16-.9v-.86a5.1,5.1,0,0,1,.15-1.08,5.3,5.3,0,0,1,.4-1.05,4.79,4.79,0,0,1,.62-.9,2.94,2.94,0,0,1,.79-.67,1.63,1.63,0,0,1,.8-.25.87.87,0,0,1,.61.2,1.33,1.33,0,0,1,.4.58A3,3,0,0,1,293.23,208.29Zm-2.62,2.31a.69.69,0,0,0,.2.55.39.39,0,0,0,.46,0,1.17,1.17,0,0,0,.47-.51,2,2,0,0,0,.2-.77c0-.12,0-.25,0-.39s0-.26,0-.37a.76.76,0,0,0-.2-.54c-.12-.09-.27-.08-.47,0a1.21,1.21,0,0,0-.46.51,1.72,1.72,0,0,0-.2.77c0,.12,0,.25,0,.39S290.6,210.5,290.61,210.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "291.27px 209.81px"
    },
    id: "el0g3dg54bwzj7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.21,210.16a.53.53,0,0,1-.06.24.41.41,0,0,1-.14.17l-.91.52a.09.09,0,0,1-.13,0,.21.21,0,0,1-.06-.17v-7.28a.53.53,0,0,1,.06-.24.34.34,0,0,1,.13-.17l.91-.52a.12.12,0,0,1,.14,0,.24.24,0,0,1,.06.18Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "294.56px 206.903px"
    },
    id: "el7nsd7qwkjkq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.34,208.93a.53.53,0,0,1-.06.24.35.35,0,0,1-.14.17l-.91.52a.09.09,0,0,1-.13,0,.21.21,0,0,1-.06-.17V202.4a.53.53,0,0,1,.06-.24.4.4,0,0,1,.13-.17l.91-.53a.14.14,0,0,1,.14,0,.24.24,0,0,1,.06.18Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "296.69px 205.664px"
    },
    id: "eln7z9actlqj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.93,203.27c0,.11,0,.25,0,.42s0,.32,0,.43a4.56,4.56,0,0,1-.16,1.09,4.72,4.72,0,0,1-.39,1,4.32,4.32,0,0,1-.61.9,2.9,2.9,0,0,1-.8.65,1.73,1.73,0,0,1-.79.27,1,1,0,0,1-.61-.2,1.37,1.37,0,0,1-.4-.59,3,3,0,0,1-.16-.91v-.85a4.48,4.48,0,0,1,.16-1.08,4.75,4.75,0,0,1,.4-1,4.67,4.67,0,0,1,.61-.91,3.27,3.27,0,0,1,.79-.66,1.66,1.66,0,0,1,.8-.26,1,1,0,0,1,.61.2,1.37,1.37,0,0,1,.4.59A3,3,0,0,1,301.93,203.27Zm-2.62,2.31a.71.71,0,0,0,.2.55.39.39,0,0,0,.46,0,1.17,1.17,0,0,0,.47-.51,2,2,0,0,0,.2-.77c0-.12,0-.25,0-.39s0-.26,0-.37a.72.72,0,0,0-.2-.54c-.12-.09-.27-.08-.47,0a1.24,1.24,0,0,0-.46.5,1.8,1.8,0,0,0-.2.78c0,.11,0,.24,0,.38S299.3,205.48,299.31,205.58Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "299.97px 204.8px"
    },
    id: "el7xiqoqsi44a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.52,198.74c.07-.05.13-.05.17,0a.33.33,0,0,1,.07.13l.54,2.21.53-2.83a.85.85,0,0,1,.08-.22.37.37,0,0,1,.17-.18l.89-.52a.09.09,0,0,1,.12,0s.05.08.05.16a.28.28,0,0,1,0,.09l-1.14,5.8a1.27,1.27,0,0,1-.08.23.35.35,0,0,1-.16.18l-.82.48c-.07,0-.12,0-.16,0a.64.64,0,0,1-.08-.14l-.51-2-.51,2.63c0,.07-.05.15-.08.23a.35.35,0,0,1-.16.18l-.82.47c-.07.05-.13.05-.16,0a.36.36,0,0,1-.08-.15L302.23,201a.22.22,0,0,1,0-.08.54.54,0,0,1,0-.22.49.49,0,0,1,.12-.15l.9-.52c.07,0,.12,0,.16,0a.26.26,0,0,1,.08.13l.53,2.21.54-2.83a.85.85,0,0,1,.08-.22.35.35,0,0,1,.16-.18Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "305.181px 201.492px"
    },
    id: "elxg0jmpvm3bf",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--button--inject-112",
    className: "animable",
    style: {
      transformOrigin: "294.825px 236.073px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--button--inject-112",
    className: "animable",
    style: {
      transformOrigin: "294.825px 236.073px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.13,211.63l-46.46,26.92c-.58.33-1.06,1.15-1.06,2.73v16.24a2.33,2.33,0,0,0,1.07,2l1.77,1a2.39,2.39,0,0,0,2.12,0L320,233.55a2.33,2.33,0,0,0,1.06-1.83V214.44a2.33,2.33,0,0,0-1.07-1.82l-1.77-1A2.39,2.39,0,0,0,316.13,211.63Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "294.835px 236.076px"
    },
    id: "el1snfgzifgas",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhiwciwy21f8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.57,260.47a2.46,2.46,0,0,1-2.12,0l-1.77-1a2.3,2.3,0,0,1-1.07-2V241.28a3.4,3.4,0,0,1,.34-2l3.87,2.24a2.28,2.28,0,0,0-.31,1.25V259C272.51,260.47,273,260.83,273.57,260.47Z",
    style: {
      opacity: 0.2,
      transformOrigin: "271.075px 249.995px"
    },
    className: "animable",
    id: "el7xmfqp0tmy5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el4sd27mos6i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.07,214.25c-.08-.53-.51-.72-1-.42l-46.46,26.92a2.2,2.2,0,0,0-.75.79l-3.88-2.24a2.1,2.1,0,0,1,.73-.75l46.46-26.92a2.36,2.36,0,0,1,2.12,0l1.77,1A2.29,2.29,0,0,1,321.07,214.25Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "295.025px 226.459px"
    },
    className: "animable",
    id: "el90eviqdaeak"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M320,213.83l-46.46,26.92a2.33,2.33,0,0,0-1.06,1.83v17.28c0,.67.48.94,1.06.61L320,233.55a2.33,2.33,0,0,0,1.06-1.83V214.44C321.09,213.77,320.61,213.5,320,213.83Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "296.771px 237.15px"
    },
    id: "ely1atsi4x3s",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281.21,242.14a1.93,1.93,0,0,1,.84-.28,1.21,1.21,0,0,1,.67.14,1.15,1.15,0,0,1,.44.46,1.41,1.41,0,0,1,.16.64.45.45,0,0,1,0,.2.33.33,0,0,1-.11.14l-.94.54a.32.32,0,0,1-.16.05l-.13-.06-.07-.07a.33.33,0,0,0-.13-.09.72.72,0,0,0-.22,0,.94.94,0,0,0-.31.13l-.27.18a1.47,1.47,0,0,0-.22.21.92.92,0,0,0-.16.27.78.78,0,0,0-.06.31.26.26,0,0,0,.3.31,2.07,2.07,0,0,0,.43-.06l.66-.18a2.29,2.29,0,0,1,.69-.09.92.92,0,0,1,.5.19,1,1,0,0,1,.29.5,2.79,2.79,0,0,1,.1.84,3.78,3.78,0,0,1-.17,1.11,4.51,4.51,0,0,1-.46,1,5,5,0,0,1-.71.89,4.88,4.88,0,0,1-.89.68,2.21,2.21,0,0,1-.89.31,1.31,1.31,0,0,1-.7-.12,1.16,1.16,0,0,1-.45-.48,1.67,1.67,0,0,1-.18-.73.53.53,0,0,1,.05-.2.36.36,0,0,1,.1-.13l.95-.54a.35.35,0,0,1,.16-.06.27.27,0,0,1,.11.05l.09.1a.58.58,0,0,0,.15.11.4.4,0,0,0,.25,0,.69.69,0,0,0,.36-.13,2.77,2.77,0,0,0,.64-.49.9.9,0,0,0,.26-.61.23.23,0,0,0-.1-.22.44.44,0,0,0-.28,0,2.42,2.42,0,0,0-.48.1l-.69.17a1,1,0,0,1-1.08-.19,2,2,0,0,1-.34-1.32,3.6,3.6,0,0,1,.14-1,4.49,4.49,0,0,1,.41-1,4.27,4.27,0,0,1,.64-.89A3.3,3.3,0,0,1,281.21,242.14Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "281.286px 246.137px"
    },
    id: "eln0fqn25c4ga",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.23,245.44a1,1,0,0,0,.06.39.35.35,0,0,0,.15.18.36.36,0,0,0,.21,0,.62.62,0,0,0,.22-.1,1.45,1.45,0,0,0,.35-.26,1.69,1.69,0,0,0,.21-.31l.11-.2a.48.48,0,0,1,.13-.09l.93-.54c.11-.07.16,0,.16.15a1.6,1.6,0,0,1-.11.47,4.14,4.14,0,0,1-.33.74,4.78,4.78,0,0,1-.59.84,3.11,3.11,0,0,1-.86.7,1.85,1.85,0,0,1-.83.28.85.85,0,0,1-.61-.24,1.52,1.52,0,0,1-.37-.73,4.42,4.42,0,0,1-.13-1.18,6,6,0,0,1,.13-1.27,4.91,4.91,0,0,1,.37-1.16,4.62,4.62,0,0,1,.61-1,3.1,3.1,0,0,1,.83-.71,1.43,1.43,0,0,1,.9-.24.93.93,0,0,1,.61.35,2,2,0,0,1,.33.78,4.67,4.67,0,0,1,.11,1v.31a.53.53,0,0,1-.06.24.35.35,0,0,1-.14.17Zm.64-2.5a1.17,1.17,0,0,0-.46.54,2.52,2.52,0,0,0-.18.73l1.29-.75a.94.94,0,0,0-.18-.51C286.23,242.83,286.08,242.82,285.87,242.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "285.874px 244.423px"
    },
    id: "elyd969d0fdz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.31,243.3a.7.7,0,0,1-.05.25.49.49,0,0,1-.14.17l-.91.52a.11.11,0,0,1-.14,0,.3.3,0,0,1-.05-.18v-2.8a1.16,1.16,0,0,0-.15-.68c-.1-.13-.26-.14-.48,0a1.11,1.11,0,0,0-.47.57,2.26,2.26,0,0,0-.15.85v2.8a.61.61,0,0,1-.06.25.36.36,0,0,1-.13.16l-.91.53a.11.11,0,0,1-.14,0,.24.24,0,0,1-.06-.18v-5.17a.53.53,0,0,1,.06-.24.41.41,0,0,1,.14-.17l.87-.5a.11.11,0,0,1,.14,0s.05.09.05.18v.25c0-.1.09-.2.15-.32a3,3,0,0,1,.21-.33,2.07,2.07,0,0,1,.28-.32,1.78,1.78,0,0,1,.38-.28,1.36,1.36,0,0,1,.63-.22.65.65,0,0,1,.5.18,1.41,1.41,0,0,1,.32.6,3.91,3.91,0,0,1,.11,1.06Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "290.391px 242.102px"
    },
    id: "elrp0rw0zujvr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.58,236.42a1,1,0,0,1,.37-.15.59.59,0,0,1,.27,0,.42.42,0,0,1,.2.1l.13.14v-2.36a.53.53,0,0,1,.06-.24.34.34,0,0,1,.13-.17l.91-.52a.11.11,0,0,1,.14,0s0,.09,0,.17v7.28a.52.52,0,0,1,0,.24.41.41,0,0,1-.14.17l-.87.5a.11.11,0,0,1-.14,0,.21.21,0,0,1-.06-.17v-.26c0,.11-.09.21-.14.32a2.58,2.58,0,0,1-.18.32,2,2,0,0,1-.28.31,1.79,1.79,0,0,1-.4.29,1.31,1.31,0,0,1-.61.21.66.66,0,0,1-.5-.18,1.23,1.23,0,0,1-.35-.59,3.53,3.53,0,0,1-.15-1c0-.11,0-.26,0-.45s0-.34,0-.45a5.74,5.74,0,0,1,.15-1.22,4.42,4.42,0,0,1,.35-1,3.3,3.3,0,0,1,.5-.77A2.53,2.53,0,0,1,294.58,236.42Zm-.32,2.87a3.21,3.21,0,0,0,0,.62,1.14,1.14,0,0,0,.16.58c.1.14.26.14.49,0a1,1,0,0,0,.27-.24,1.23,1.23,0,0,0,.19-.31,2.42,2.42,0,0,0,.12-.35,2.25,2.25,0,0,0,.06-.36c0-.12,0-.25,0-.4s0-.27,0-.38a1.15,1.15,0,0,0-.06-.28.66.66,0,0,0-.12-.22.26.26,0,0,0-.19-.09.44.44,0,0,0-.27.08,1.12,1.12,0,0,0-.49.56A2.58,2.58,0,0,0,294.26,239.29Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "294.887px 237.898px"
    },
    id: "elv4ask5m37qi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.11,235.91a.7.7,0,0,1-.05.25.41.41,0,0,1-.14.17l-.87.5c-.06,0-.1,0-.14,0a.24.24,0,0,1-.06-.18V233.8a1.23,1.23,0,0,0-.13-.71q-.14-.15-.39,0a.87.87,0,0,0-.39.45,2.28,2.28,0,0,0-.13.87v2.83a.54.54,0,0,1-.06.25.35.35,0,0,1-.14.17l-.87.5a.11.11,0,0,1-.14,0,.3.3,0,0,1-.05-.18v-2.84a1.21,1.21,0,0,0-.14-.71q-.14-.15-.39,0a.86.86,0,0,0-.38.45,2.07,2.07,0,0,0-.14.83v2.88a.69.69,0,0,1-.05.24.41.41,0,0,1-.14.17l-.91.52a.11.11,0,0,1-.14,0,.28.28,0,0,1-.05-.18v-5.16a.7.7,0,0,1,.05-.25.49.49,0,0,1,.14-.17l.87-.5c.06,0,.1,0,.14,0a.24.24,0,0,1,.06.18v.25a3.21,3.21,0,0,1,.38-.71,1.85,1.85,0,0,1,.53-.48,1.06,1.06,0,0,1,.67-.17.63.63,0,0,1,.48.37,4,4,0,0,1,.51-.94,2.22,2.22,0,0,1,.65-.59,1.11,1.11,0,0,1,.57-.18.56.56,0,0,1,.45.2,1.34,1.34,0,0,1,.3.61,4.57,4.57,0,0,1,.1,1.07Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "302.16px 235.267px"
    },
    id: "elydhg933njmo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.67,234.25a3,3,0,0,1,.36-1.42,4.86,4.86,0,0,1,1.19-1.38l.84-.71a.62.62,0,0,0-.09-.38c-.07-.08-.17-.08-.33,0a.92.92,0,0,0-.25.22,2.51,2.51,0,0,0-.14.21.7.7,0,0,1-.12.18.5.5,0,0,1-.14.1l-.91.53q-.07,0-.12,0a.21.21,0,0,1,0-.15,2.44,2.44,0,0,1,.14-.62,4.37,4.37,0,0,1,.9-1.42,3.1,3.1,0,0,1,.68-.54,1.91,1.91,0,0,1,.77-.28.78.78,0,0,1,.53.15,1.08,1.08,0,0,1,.32.52,3.31,3.31,0,0,1,.1.83v3.36a.54.54,0,0,1-.06.25.41.41,0,0,1-.14.17l-.91.52a.09.09,0,0,1-.13,0,.24.24,0,0,1-.06-.18v-.31a3.65,3.65,0,0,1-.43.78,2.12,2.12,0,0,1-.67.58,1.14,1.14,0,0,1-.55.18.54.54,0,0,1-.41-.13.87.87,0,0,1-.25-.41A2.46,2.46,0,0,1,305.67,234.25Zm1.64-.69a1.37,1.37,0,0,0,.3-.25,1.76,1.76,0,0,0,.23-.37,2,2,0,0,0,.16-.43,1.74,1.74,0,0,0,.06-.45l-.66.54a1.4,1.4,0,0,0-.32.37.78.78,0,0,0-.12.41q0,.21.09.24A.36.36,0,0,0,307.31,233.56Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "307.535px 232.015px"
    },
    id: "eldlecmiger58",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.45,225.88a.53.53,0,0,1-.06.24.34.34,0,0,1-.13.17l-.91.52a.11.11,0,0,1-.14,0s0-.09,0-.17v-1.12a.53.53,0,0,1,0-.25.49.49,0,0,1,.14-.17l.91-.52a.09.09,0,0,1,.13,0,.24.24,0,0,1,.06.18Zm0,6.37a.54.54,0,0,1-.06.25.34.34,0,0,1-.13.17l-.91.52a.11.11,0,0,1-.14,0,.24.24,0,0,1,0-.18v-5.17a.52.52,0,0,1,0-.24.41.41,0,0,1,.14-.17l.91-.52a.09.09,0,0,1,.13,0,.24.24,0,0,1,.06.18Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "310.822px 228.884px"
    },
    id: "eliuyzhj8bg4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.58,231a.74.74,0,0,1-.05.25.41.41,0,0,1-.14.17l-.91.52a.11.11,0,0,1-.14,0,.3.3,0,0,1,0-.18V224.5a.74.74,0,0,1,0-.25.38.38,0,0,1,.14-.16l.91-.53a.11.11,0,0,1,.14,0,.3.3,0,0,1,.05.18Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "312.953px 227.75px"
    },
    id: "elsetrbvauf1f",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-112",
    className: "animable",
    style: {
      transformOrigin: "369.094px 262.709px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-112",
    className: "animable",
    style: {
      transformOrigin: "369.094px 262.709px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-112",
    className: "animable",
    style: {
      transformOrigin: "378.225px 324.884px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "362.95 401.48 357.24 399.3 359.13 395.44 362.63 398.73 362.95 401.48",
    id: "eli4kx212sceq",
    className: "animable",
    style: {
      transformOrigin: "360.095px 398.46px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.91,391.19s.21,3.72.25,4.89-5,4.8-6.21,5.39l-.32-2.74a21.2,21.2,0,0,0-2.89,4.43c-1,1.66-2.21,4.82-4.86,7-3.95,3.18-10.08,4.77-16.32,5s-9.82-1.35-11.59-2.71-2.32-2.95-1.87-4.54S368.91,391.19,368.91,391.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "347.055px 403.186px"
    },
    id: "elkt85j9np9x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.26,378.4l-.06-2.16c-1.16,0-1.31,3.09-3,5.83a56,56,0,0,1-8.84,11.19c-6.36,5.75-12,9.34-14.87,11.93-3.8,3.46,2.82,9,13,8.49,5.07-.26,14.06-2.76,16.6-5.74s4.12-7.63,6.15-9.79,6.38-4.33,7.66-7c.7-1.45.35-4.83-.05-7.71-.37-2.64-.43-6.68-1.92-6.36l-.11,1.36c-.61,1.15-2,3-6.11,3.71C358.68,382.53,352.6,382.68,352.26,378.4Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "346.853px 394.976px"
    },
    id: "el563g9jsnuak",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1gvd8bwchcg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.44,382.29c-1.94-.18-4-.84-4.84-2.59,0,0,0,0,0-.06a5,5,0,0,1-1.33,4.15c-1.84,2.12-13.42,17.11-13.42,17.11s10.77-12.36,12.84-14.69c3.06-3.44,4-3.84,6.8-3.92Z",
    style: {
      opacity: 0.15,
      transformOrigin: "347.67px 390.27px"
    },
    className: "animable",
    id: "elwc3gt4k7hwj"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elum6ihcuu2ld"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.88,386.26a.62.62,0,0,0,1.24-.13.64.64,0,0,0-.69-.56A.63.63,0,0,0,354.88,386.26Z",
    style: {
      opacity: 0.15,
      transformOrigin: "355.5px 386.193px"
    },
    className: "animable",
    id: "elkao3a5akxr"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eljfwk51ll9ts"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.85,389.57a.64.64,0,0,0,.69.56.63.63,0,0,0,.55-.69.61.61,0,0,0-.68-.55A.63.63,0,0,0,351.85,389.57Z",
    style: {
      opacity: 0.15,
      transformOrigin: "352.471px 389.509px"
    },
    className: "animable",
    id: "elxi0zt13xqo"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elizr284hn8vp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.83,392.88a.62.62,0,1,0,1.24-.13.62.62,0,0,0-.69-.55A.61.61,0,0,0,348.83,392.88Z",
    style: {
      opacity: 0.15,
      transformOrigin: "349.45px 392.818px"
    },
    className: "animable",
    id: "elt45ygzii1e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0mu8ld5jldtl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.81,396.19a.62.62,0,0,0,.68.56.64.64,0,0,0,.56-.69.63.63,0,0,0-.69-.55A.61.61,0,0,0,345.81,396.19Z",
    style: {
      opacity: 0.15,
      transformOrigin: "346.429px 396.13px"
    },
    className: "animable",
    id: "elnx2i5phc6oj"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elti7jixw1hq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.78,399.51a.62.62,0,0,0,1.24-.14.61.61,0,0,0-.68-.55A.63.63,0,0,0,342.78,399.51Z",
    style: {
      opacity: 0.15,
      transformOrigin: "343.4px 399.439px"
    },
    className: "animable",
    id: "elswvmevhf6j"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M355.52,386.45a.27.27,0,0,0,.16-.08.26.26,0,0,0,0-.35,10.3,10.3,0,0,0-7-2.83h0a.27.27,0,0,0-.24.27.26.26,0,0,0,.27.24c3.7-.2,6.62,2.64,6.65,2.67A.27.27,0,0,0,355.52,386.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "352.094px 384.82px"
    },
    id: "elh58oz2si9xv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.49,389.74a.2.2,0,0,0,.16-.07.24.24,0,0,0,0-.35,10.27,10.27,0,0,0-7-2.83h0a.26.26,0,0,0,0,.51c3.7-.2,6.63,2.64,6.66,2.67A.2.2,0,0,0,352.49,389.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "349.083px 388.116px"
    },
    id: "ell52qj9mqwv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.47,393.07a.27.27,0,0,0,.16-.08.24.24,0,0,0,0-.35,10.24,10.24,0,0,0-7-2.82h0a.25.25,0,0,0,0,.5c3.7-.2,6.63,2.65,6.65,2.68A.31.31,0,0,0,349.47,393.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "346.043px 391.445px"
    },
    id: "el37za4jf0g6s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.45,396.38a.37.37,0,0,0,.16-.07.26.26,0,0,0,0-.36,10.25,10.25,0,0,0-7-2.82h0a.25.25,0,0,0-.23.26.26.26,0,0,0,.27.24c3.69-.2,6.62,2.65,6.65,2.68A.29.29,0,0,0,346.45,396.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "343.031px 394.755px"
    },
    id: "elg2g0ioqikvb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.42,399.69a.24.24,0,0,0,.16-.07.25.25,0,0,0,0-.36,10.29,10.29,0,0,0-7-2.82h0a.25.25,0,0,0-.23.26.24.24,0,0,0,.26.24c3.7-.2,6.63,2.65,6.66,2.68A.26.26,0,0,0,343.42,399.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "340.003px 398.065px"
    },
    id: "elrwt938zf12",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.67,419.46c.87,4.87,2,8,4.1,10.71s5.83,3,8.61,2.39a11.93,11.93,0,0,0,9.24-9.12c.9-3.36.28-7.22-1-11.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "420.858px 422.294px"
    },
    id: "elxwwkvvktvo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.52,382c1.38-.06,2.57,6.48,4.15,13,1.69,7,4.32,10.67,5.59,15.35,1.76,6.5,1.66,9.52-.19,13.81s-11.43,9.5-16.16,4.25c-3.86-4.29-4.61-9.45-5.1-16.1a166.88,166.88,0,0,0-1.7-16.87c-.85-4.93-1.77-9.7-.64-10.39.17.72.37,1.63.56,2.33.14.54.59,3.21,1.36,3.15a9.9,9.9,0,0,0-.2-1.87,2.23,2.23,0,0,1,.18-1.65,2.66,2.66,0,0,1,1.44-.86,40.22,40.22,0,0,1,4-1.11,20.61,20.61,0,0,1,2-.33,23.29,23.29,0,0,1,3.61-.28,1.23,1.23,0,0,1,.83.58,2.39,2.39,0,0,1,.16.75,5.16,5.16,0,0,0,.33,1.34c.07.19.24.41.43.34s.19-.26.17-.43c-.09-.79-.26-1.36-.4-2.29-.07-.43-.21-1-.27-1.43S420.6,382.46,420.52,382Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "418.733px 406.309px"
    },
    id: "elclu09nefws6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnnqkt6hxizk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.43,412.61a.48.48,0,0,1-.36.58.5.5,0,0,1-.58-.37.49.49,0,0,1,.37-.58A.48.48,0,0,1,425.43,412.61Z",
    style: {
      opacity: 0.15,
      transformOrigin: "424.961px 412.714px"
    },
    className: "animable",
    id: "elb8w7oeiawtf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el55vgnwabe8q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.43,408.09a.49.49,0,0,1-.37.58.47.47,0,0,1-.57-.37.47.47,0,0,1,.36-.57A.48.48,0,0,1,424.43,408.09Z",
    style: {
      opacity: 0.15,
      transformOrigin: "423.959px 408.2px"
    },
    className: "animable",
    id: "el3od906mez6x"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elggwyocwu7g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.48,403.83a.49.49,0,0,1-.37.58.48.48,0,0,1-.57-.37.48.48,0,0,1,.94-.21Z",
    style: {
      opacity: 0.15,
      transformOrigin: "423.01px 403.939px"
    },
    className: "animable",
    id: "elypiwldjevmh"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el7anceb57gt9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.55,399.63a.49.49,0,0,1-.37.58.49.49,0,0,1-.21-.95A.5.5,0,0,1,422.55,399.63Z",
    style: {
      opacity: 0.15,
      transformOrigin: "422.102px 399.732px"
    },
    className: "animable",
    id: "elwsbyxheczlk"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellziejmn909k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.78,401.6a.47.47,0,0,1-.36.57.48.48,0,0,1-.58-.36.49.49,0,0,1,.37-.58A.48.48,0,0,1,411.78,401.6Z",
    style: {
      opacity: 0.15,
      transformOrigin: "411.311px 401.701px"
    },
    className: "animable",
    id: "eloou4kqcvpvf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ell7cz9qs76n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.72,405.83a.47.47,0,0,1-.36.57.48.48,0,0,1-.58-.36.49.49,0,0,1,.37-.58A.48.48,0,0,1,412.72,405.83Z",
    style: {
      opacity: 0.15,
      transformOrigin: "412.251px 405.931px"
    },
    className: "animable",
    id: "el4z2omyumvxt"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el7uzkas2xt88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.67,410.09a.48.48,0,1,1-.94.21.48.48,0,0,1,.36-.58A.5.5,0,0,1,413.67,410.09Z",
    style: {
      opacity: 0.15,
      transformOrigin: "413.2px 410.195px"
    },
    className: "animable",
    id: "elm8u00kbgek"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3jqy9zv1qhe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.67,414.61a.47.47,0,0,1-.36.57.48.48,0,0,1-.58-.36.49.49,0,0,1,.37-.58A.47.47,0,0,1,414.67,414.61Z",
    style: {
      opacity: 0.15,
      transformOrigin: "414.201px 414.71px"
    },
    className: "animable",
    id: "elpy50gndj618"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhyg8zzy9j3k"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "418.96 416.28 411.48 384.83 413.25 384.58 418.96 416.28",
    style: {
      opacity: 0.15,
      transformOrigin: "415.22px 400.43px"
    },
    className: "animable",
    id: "elfx5tvil1t3f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M425,413h-.07c-3.25-.33-8.62.64-10.61,1.93a.25.25,0,0,1-.34-.08.24.24,0,0,1,.07-.33c2.12-1.37,7.52-2.35,10.92-2a.24.24,0,0,1,0,.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "419.576px 413.707px"
    },
    id: "el8kow4a15eer",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,408.44a.29.29,0,0,1-.13,0c-2.55-.86-8.28.47-10.56,1.94a.23.23,0,0,1-.33-.07.24.24,0,0,1,.07-.34c2.37-1.53,8.28-2.9,11-2a.25.25,0,0,1,.16.31A.26.26,0,0,1,424,408.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "418.579px 409.053px"
    },
    id: "elllo3gpf5yo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.06,404.18h-.13c-2.55-.86-8.27.47-10.55,1.94A.24.24,0,0,1,412,406a.25.25,0,0,1,.07-.34c2.37-1.54,8.28-2.9,11-2a.25.25,0,0,1,.15.31A.26.26,0,0,1,423.06,404.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "417.597px 404.772px"
    },
    id: "elfw30eaarkls",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.13,400H422c-2.55-.86-8.28.47-10.56,1.94a.25.25,0,0,1-.34-.08.23.23,0,0,1,.08-.33c2.37-1.54,8.28-2.9,11-2a.25.25,0,0,1,.16.31A.22.22,0,0,1,422.13,400Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "416.706px 400.609px"
    },
    id: "el1jcm310xbte",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.91,221c3.2,40.54,6.34,96.42,6.34,96.42.29,3.08,3.25,16.21,4.74,31.4,1.57,16,2.84,46,2.84,46s-11.21,6-20.28,3c0,0-9.73-50.53-14.39-69.41-4.41-17.87-11.29-51.73-11.29-51.73l-4.7,33.5s.62,11.56.28,19.64c-.4,9.4-6.4,54.59-6.4,54.59s-12.18,7.18-21.61,0c0,0-1.63-62.32-1.9-73.64-.52-22.18,2.07-65.18,2.88-93.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "385.651px 307.8px"
    },
    id: "eldfx4dz2r225",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.61,268.32q1.27,14.56,2.84,29.12.76,7.28,1.59,14.54l.82,7.26.43,3.64c.13,1.21.38,2.4.57,3.61,1.6,9.61,4.06,27.08,5.8,36.68s3.6,19.17,5.58,28.72q-1.89-14.52-4.15-28.95c-1.51-9.62-3.86-27.1-5.51-36.7-.19-1.21-.44-2.4-.58-3.61l-.45-3.63-.91-7.25q-.92-7.25-1.89-14.49Q398.81,282.79,396.61,268.32Z",
    id: "elgllkr7as054",
    className: "animable",
    style: {
      transformOrigin: "405.425px 330.105px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.72,265.57c-1,9.06-1.55,18.17-1.94,27.28s-.75,18.24-.41,27.35.46,24.38.8,33.49.75,18.22,1.3,27.32q.21-13.68.08-27.34c-.06-9.11-.22-24.38-.41-33.48l-.17-6.83,0-1.71,0-1.69,0-3.42.17-13.65.22-13.66C351.43,274.67,351.57,270.12,351.72,265.57Z",
    id: "el6s0dwb47o2",
    className: "animable",
    style: {
      transformOrigin: "350.477px 323.29px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.87,276.68l-4-22.2s-11-1.61-16.64-6.67c0,0,3.63,6.69,14,9.32l3.93,19.61-2,33.44Z",
    id: "el94fboa6tpqu",
    className: "animable",
    style: {
      transformOrigin: "369.55px 278.995px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-112",
    className: "animable",
    style: {
      transformOrigin: "369.094px 167.254px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.42,148.83c-6,1-11.8,4-16.32,13-3.71,7.39-4.56,13.79-10.41,25.46l-24.44-.4,4.35,15.62s14.58,2.6,22.12,3.2c5.64.44,7.91-1.07,11.34-5.67,4.48-6,10.73-20.11,10.73-20.11Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "333.835px 177.306px"
    },
    id: "el9qv9il3q12",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzi72rruj1s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.42,148.83c-6,1-11.8,4-16.32,13-3.71,7.39-4.56,13.79-10.41,25.46l-24.44-.4,4.35,15.62s14.58,2.6,22.12,3.2c5.64.44,7.91-1.07,11.34-5.67,4.48-6,10.73-20.11,10.73-20.11Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.35,
      transformOrigin: "333.835px 177.306px"
    },
    className: "animable",
    id: "elj7zjjqkq54q"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-112",
    className: "animable",
    style: {
      transformOrigin: "382.225px 193.889px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-112",
    d: "M393.39,145.86c9.89,2.22,12.86,3.18,17.53,4.27,0,0,8.71,24.65,4.52,41.84-1,3.95-1.68,14.85-2.34,23.27a99.27,99.27,0,0,0,0,19.7s-13.23,9.27-40.9,6.44c-21.72-2.22-24.33-10.31-24.33-10.31s.53-29.68,1.52-45.72c1.31-21.06,7.58-33.65,10-36.52.77-.45,15.51-2.67,15.51-2.67Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "382.225px 193.889px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-112"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.39,145.86c9.89,2.22,12.86,3.18,17.53,4.27,0,0,8.71,24.65,4.52,41.84-1,3.95-1.68,14.85-2.34,23.27a99.27,99.27,0,0,0,0,19.7s-13.23,9.27-40.9,6.44c-21.72-2.22-24.33-10.31-24.33-10.31s.53-29.68,1.52-45.72c1.31-21.06,7.58-33.65,10-36.52.77-.45,15.51-2.67,15.51-2.67Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "382.225px 193.889px"
    },
    className: "animable",
    id: "el0dhfi8d4yjva"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-112",
    className: "animable",
    style: {
      transformOrigin: "384.376px 123.896px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.53,106.93a7.9,7.9,0,0,0-4.24-3.93h0c-.85-4.56-6.7-9.93-17.87-10.38-9.15-.38-14.46,2.84-17.58,8.21s-.93,12.25-.93,12.25L390.15,111a15.67,15.67,0,0,0-.13,4.53c.44,4.06,5.05,8.14,5.05,8.14l-.23,5.66-.11,8.11a5.21,5.21,0,0,0,3-2.45,42.7,42.7,0,0,0,4.93-11.72C405.41,112.63,404.61,109,403.53,106.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "383.347px 115.015px"
    },
    id: "el9db2g55i0ar",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.29,131.56c-4.18,2.1-6.14-1.21-6.14-1.21l-.42,18.23c-7.94,10.91-29.53,6.83-20.8-1.37l0-5.14a29,29,0,0,1-3.64-.34c-3.73-.54-6.11-3.16-7.27-7.18-1.71-5.94-2.47-15.48-.35-25.66.41-2,1.23-4.12,3-5,4.44-2.27,8.61.87,14.86,3.21,2.59,1,8.85,1.34,10.49.55-2.14,2.42-.81,8.62-.21,10.57.87,2.83,2.08,4.19,2.68,4.31,2.55.51,2.82-1.69,3.95-2.9a4.7,4.7,0,0,1,7.32,1.59A7.65,7.65,0,0,1,402.29,131.56Z",
    style: {
      fill: "rgb(158, 103, 103)",
      transformOrigin: "384.484px 129.154px"
    },
    id: "el554kbq0oo8t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.74,137.06c-.83,4.13-6.37,6.91-15.82,7.26l0-2.25a44.24,44.24,0,0,0,6.93-.71C386.24,140.57,390.74,137.06,390.74,137.06Z",
    style: {
      fill: "rgb(135, 76, 76)",
      transformOrigin: "382.83px 140.69px"
    },
    id: "el38d6zfpmvm4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.34,113.7l4.13,1.73a2.34,2.34,0,0,0-1.24-3A2.19,2.19,0,0,0,381.34,113.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "383.486px 113.847px"
    },
    id: "elpoo94iq801",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.79,114.86l4.32-1.31a2.17,2.17,0,0,0-2.74-1.55A2.37,2.37,0,0,0,365.79,114.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "367.911px 113.383px"
    },
    id: "eltfxfez3jcc9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,118.12a1.83,1.83,0,1,1-1.78-1.87A1.82,1.82,0,0,1,384,118.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "382.171px 118.079px"
    },
    id: "elq36z7xacuns",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.22,118a1.83,1.83,0,1,1-1.79-1.87A1.67,1.67,0,0,1,370.22,118Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "368.397px 117.957px"
    },
    id: "ely7kycymqd4g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.68,115.88,375,126.72l-5.62-1.33A21.65,21.65,0,0,1,376.68,115.88Z",
    style: {
      fill: "rgb(135, 76, 76)",
      transformOrigin: "373.03px 121.3px"
    },
    id: "elxulest3dopj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.29,128.07l-6.3,2.44a3.33,3.33,0,0,0,4.32,2.05A3.55,3.55,0,0,0,380.29,128.07Z",
    style: {
      fill: "rgb(135, 76, 76)",
      transformOrigin: "377.246px 130.42px"
    },
    id: "el80hg4rk1xql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.67,129.26a3.78,3.78,0,0,1,.81-.12,3.51,3.51,0,0,1-2.17,3.42,3.32,3.32,0,0,1-1.07.2A3.09,3.09,0,0,1,379.67,129.26Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "378.844px 130.95px"
    },
    id: "elxtppm0utk9",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-112",
    className: "animable",
    style: {
      transformOrigin: "329.393px 192.388px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.51,164.9h0l1.6-1.06h0a1.66,1.66,0,0,1,1.51,0l41.05,16.82a5.8,5.8,0,0,1,3.11,3.71L357,218.2a1.51,1.51,0,0,1-.41,1.63h0l-1.64,1.1v0a1.64,1.64,0,0,1-1.52,0l-41-16.82a5.8,5.8,0,0,1-3.11-3.71L302,166.58C301.84,165.75,302.05,165.16,302.51,164.9Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "329.518px 192.388px"
    },
    id: "elqzrzd8p4kil",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.62,182.87a5.67,5.67,0,0,1,1.52,2.6l7.29,33.79a1.57,1.57,0,0,1-.36,1.61l1.54-1h0a1.5,1.5,0,0,0,.42-1.63l-7.29-33.81a5.53,5.53,0,0,0-1.39-2.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "351.869px 201.42px"
    },
    id: "el6q7bb6rgr19",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.42,219.27l-7.28-33.8a5.8,5.8,0,0,0-3.11-3.71l-41-16.82c-1.4-.57-2.28.16-2,1.64l7.28,33.8a5.8,5.8,0,0,0,3.11,3.71l41,16.82C354.86,221.48,355.74,220.75,355.42,219.27Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "328.732px 192.925px"
    },
    id: "elu3egw6td4il",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,181.76,335.46,178l-9.55-3.86-19.08-7.72-2.38-1a4.74,4.74,0,0,0-1.15-.39.92.92,0,0,0-.92.31c-.4.58,0,1.48.1,2.31l.53,2.52,2.13,10.07,2.12,10.07,2,10.09-2.29-10-2.21-10.06-2.21-10-.56-2.51c-.09-.43-.19-.83-.27-1.27A2,2,0,0,1,302,165a1.39,1.39,0,0,1,1.37-.52,5.2,5.2,0,0,1,1.28.42l2.39,1,19,7.89,9.51,4Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "323.334px 182.427px"
    },
    id: "elpzy45h93t1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.29,192.26l-1.36-6.32a1.11,1.11,0,0,0-.59-.7l-2.82-1.15c-.27-.1-.43,0-.37.31.27,1.24,1.1,5.08,1.36,6.33a1.11,1.11,0,0,0,.58.69l2.83,1.15C347.18,192.68,347.35,192.54,347.29,192.26Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "344.72px 188.33px"
    },
    id: "el02hgpvt4i6oo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.6,187.37a2.74,2.74,0,0,0-1.48-1.72c-.68-.27-1.11,0-1,.72a2.73,2.73,0,0,0,1.49,1.72C345.32,188.37,345.75,188.05,345.6,187.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "344.366px 186.869px"
    },
    id: "elx27lmpchc3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.25,190.56a2.73,2.73,0,0,0-1.49-1.72c-.67-.27-1.1,0-1,.72a2.75,2.75,0,0,0,1.49,1.72C346,191.55,346.4,191.23,346.25,190.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "345.013px 190.057px"
    },
    id: "el96hl0mevhnp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.44,186.52c-1.33-2.08-1.19-2.34-.36-3.32a6.35,6.35,0,0,1,5.27-2.36c1.76.15,3.54.21,4.42.72s0,2.39-2.31,2.78c-3.65.62-3.68,1.61-3.68,1.61a46.67,46.67,0,0,1,4.71-.58,34.68,34.68,0,0,1,5.26,1.08c1.51.33,1.71,2.31-.91,2.85l2.77.59c1.93.42,2.55,1.49.95,2.62a2.9,2.9,0,0,1-1.81.58s2.08.1,2.09.8c0,2-1.29,2.44-5.57,3.44-4.07,1-5,3.08-4.29,4.61,0,0-1.57-1-3-2.1-1-.78-1.87-1.65-1.3-3.27,0,0-2.3-.07-2.36-1.5a7.29,7.29,0,0,1,.71-3,2.51,2.51,0,0,1-1.14-2.42,4.12,4.12,0,0,1,1-2.45Z",
    style: {
      fill: "rgb(158, 103, 103)",
      transformOrigin: "311.46px 191.386px"
    },
    id: "el710bcnsn9eh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.84,189.3a13,13,0,0,0-2.53-.41,8.6,8.6,0,0,0-2.49.65,29.93,29.93,0,0,0-4.55,2.14,31.26,31.26,0,0,0,4.8-1.44,12.34,12.34,0,0,1,2.29-.77C314.12,189.38,315,189.41,315.84,189.3Z",
    style: {
      fill: "rgb(135, 76, 76)",
      transformOrigin: "311.055px 190.285px"
    },
    id: "elyw21iqnlsio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.75,193.09a5.53,5.53,0,0,0-2.74-.23,14.84,14.84,0,0,0-2.66.69,25.82,25.82,0,0,0-4.91,2.3c1.78-.42,3.47-1,5.16-1.6A14.1,14.1,0,0,1,317.75,193.09Z",
    style: {
      fill: "rgb(135, 76, 76)",
      transformOrigin: "312.595px 194.316px"
    },
    id: "elrpaxzx6kdb",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-112",
    className: "animable",
    style: {
      transformOrigin: "400.955px 187.051px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-112",
    className: "animable",
    style: {
      transformOrigin: "400.77px 187.046px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.91,178.89c-3.37-2.85-5.09-4-6.71-4.55s-7.24-3.33-9.42-4c-1.39-.44-2.09,1.76-.4,3.41,1.3,1.27,4.79,3,6.31,4s4.37,4.9,4.37,4.9Z",
    style: {
      fill: "rgb(135, 76, 76)",
      transformOrigin: "374.15px 176.466px"
    },
    id: "el4y3855z1f8p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.51,163.71c-3-7.68-6-10-13.92-12.54-8.46,7.28-3.73,27.45-3.73,27.45l7.6,21.27s-17.1-5.89-19.4-7.56-8.28-9-10.3-11.17c-2.75-3-4.23-2.7-5.73-2.57-4.91.43-6,.77-7.08,1.36a2.21,2.21,0,0,0-1.06,1.84c-1.31.08-3.24-.08-3.62,2a6.45,6.45,0,0,0-.19,1.7,1.37,1.37,0,0,0-.87.43c-1.15,1.18.43,5.61,1.53,6.73.78.79,1.95,1,3.5.85,1.33-.1.8-1.47.8-1.47l1.83.22c3.78,3.06,3.64,8.65,8.8,10.2a36.16,36.16,0,0,1,6.32,1.64c11,4.49,25.16,17.11,35.16,18.6,9.75,1.46,11-4.24,11-10.26C436,202.84,428.54,171.37,425.51,163.71Z",
    style: {
      fill: "rgb(158, 103, 103)",
      transformOrigin: "401.48px 187.046px"
    },
    id: "eloqog6qxt3ds",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.82,197.22l.64,2.67c4.39,1.42,9,4.94,9.94,7.45C424.8,203.41,422.55,199.8,414.82,197.22Z",
    style: {
      fill: "rgb(135, 76, 76)",
      transformOrigin: "420.11px 202.28px"
    },
    id: "el580r62498yh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.89,181.79l6.2-.2-6-.59A2.06,2.06,0,0,0,371.89,181.79Z",
    style: {
      fill: "rgb(135, 76, 76)",
      transformOrigin: "374.99px 181.395px"
    },
    id: "el0jvmd3mfz0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.08,185.52l6.72-.45-6.68-.33A3.92,3.92,0,0,0,368.08,185.52Z",
    style: {
      fill: "rgb(135, 76, 76)",
      transformOrigin: "371.438px 185.13px"
    },
    id: "el4me6mlc8vrt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.78,188.5a2.08,2.08,0,0,0,.85.84,4.34,4.34,0,0,0,1.11.46l-.08-.07c.15.36.32.71.49,1.06l.15-.17a1.33,1.33,0,0,0-1.07.2,1.74,1.74,0,0,0-.64.83,2,2,0,0,1,.73-.68,1.32,1.32,0,0,1,.91-.11l.25.07-.1-.24c-.16-.36-.32-.72-.5-1.07l0-.05-.06,0a6.09,6.09,0,0,1-1.09-.37A2.49,2.49,0,0,1,368.78,188.5Z",
    style: {
      fill: "rgb(135, 76, 76)",
      transformOrigin: "370.13px 190.075px"
    },
    id: "elyjujxpsonj9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.49,189.47a20.5,20.5,0,0,0,2.4.32,2.71,2.71,0,0,0,.75,1.33,13.22,13.22,0,0,0,1.23,1.16l-1.83-.22a3,3,0,0,0-2-1.27Z",
    style: {
      fill: "rgb(135, 76, 76)",
      transformOrigin: "372.68px 190.875px"
    },
    id: "el4fj2y4sy4xv",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M410.92,150.13c-2.48,1.43-7.29,9.86-4.34,23.89a120.62,120.62,0,0,0,8.67,25.63l-10.33-3.55s.37,5.89-1.38,9.66-3.86,3.53-3.86,3.53,3.19,2.49,9.43,6.56,14.91,9.26,20.94,7.9,6.67-6.25,6.43-13-6.14-30.72-7.74-37.69S426.07,153.85,410.92,150.13Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "418.101px 187.051px"
    },
    id: "eltkivaewq3bc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "els91xnrtus6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.92,150.13c-2.48,1.43-7.29,9.86-4.34,23.89a120.62,120.62,0,0,0,8.67,25.63l-10.33-3.55s.37,5.89-1.38,9.66-3.86,3.53-3.86,3.53,3.19,2.49,9.43,6.56,14.91,9.26,20.94,7.9,6.67-6.25,6.43-13-6.14-30.72-7.74-37.69S426.07,153.85,410.92,150.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.35,
      transformOrigin: "418.101px 187.051px"
    },
    className: "animable",
    id: "elj2s4hxuxwfp"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eluwxmyirubzk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.25,199.65c4.22,1.13,9.55,5.8,10.58,8.16-1.21-5.17-4.17-9.57-11.4-11.23Z",
    style: {
      fill: "#90CAF9",
      opacity: 0.3,
      transformOrigin: "420.13px 202.195px"
    },
    className: "animable",
    id: "elhhnqsar9k0t"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-112",
    className: "animable",
    style: {
      transformOrigin: "214.346px 190.103px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--profile-photo--inject-112",
    className: "animable",
    style: {
      transformOrigin: "214.346px 190.103px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.78,160c0,33.21-23.32,73.6-52.09,90.21s-52.08,3.14-52.08-30.07,23.32-73.6,52.08-90.21S257.78,126.82,257.78,160Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "205.695px 190.073px"
    },
    id: "el1i06k6po6vi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elh2h9qf0pazj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.78,160c0,33.21-23.32,73.6-52.09,90.21s-52.08,3.14-52.08-30.07,23.32-73.6,52.08-90.21S257.78,126.82,257.78,160Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "205.695px 190.073px"
    },
    className: "animable",
    id: "el5xamcd0fzd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.43,259.69a29,29,0,0,1-14.72-3.8c-10.58-6.11-16.41-18.8-16.41-35.72,0-33.9,23.88-75.26,53.24-92.21,14.66-8.46,28.56-9.76,39.14-3.65s16.41,18.8,16.41,35.72c0,33.9-23.89,75.26-53.24,92.21C198.28,257.19,190,259.69,182.43,259.69ZM229,125.14c-6.73,0-14.25,2.29-22.1,6.82-28.08,16.21-50.93,55.78-50.93,88.21,0,15.2,5,26.47,14.1,31.72s21.35,4,34.52-3.65C232.62,232,255.47,192.46,255.47,160c0-15.2-5-26.47-14.1-31.72A24.55,24.55,0,0,0,229,125.14Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "205.695px 190.103px"
    },
    id: "el5crl8lyxikr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-112",
    className: "animable",
    style: {
      transformOrigin: "216.356px 188.01px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.36,176.8c8.28,0,9,1.24,19,6.46,5.67,3,13.85,7.38,13.85,7.38l.62-1.12a5.61,5.61,0,0,1,7.39-1c4.39,2.68,7.63,5.39,9.38,9.59-2.71,10.86-5.41,14.36-11.48,13.5C250.7,211,226.66,202,226.66,202Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "241.48px 194.267px"
    },
    id: "elld1k37i4z2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.35,190.08c1.47-.64,3.67.36,3.69,1.61,0,0,1.54-1.6,1-3.12S253.16,187.09,251.35,190.08Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "253.752px 189.636px"
    },
    id: "ell1y3jhhh23",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hand--inject-112",
    className: "animable",
    style: {
      transformOrigin: "264.251px 162.997px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.11,186.7s9.64-21.92,9.84-24.07c1.93,2.62,4.4-1.34,7.72-.16,2.3.82,3.3,2.77,3.47,5.09-3.29,24.64-5.09,29-5.09,29C262.83,191.38,257.88,187.78,251.11,186.7Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "261.625px 179.402px"
    },
    id: "elzou2voumm4e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.52,167.24s-.15-4.11-3.27-5.53c-2.08-1-4.16.45-5.78.84s-1.86-.35-2.73-1.38a40.13,40.13,0,0,1-2.82-4.34c-.39-.83.67-2.7,1-3.28s1.32-1.69,1.67-1.68,1.06,1.22,1.31.36.07-3.41.39-5.14,7.42-1.45,11.2-.43c2.62.71,4.26,1.09,3.74,5.23C276.57,158.1,274.64,166.82,272.52,167.24Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "267.581px 156.542px"
    },
    id: "elvbrou23u6tl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.51,155.47a15.2,15.2,0,0,1-1.59-4.31c-.15-.62,1.43-2.49,2-2.36s1.78,1.83,1.84,2.94A7.51,7.51,0,0,0,257.51,155.47Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "257.835px 152.132px"
    },
    id: "elqcxcsifkuxq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.74,150.18a5,5,0,0,1,1.88-1.82c.45-.19-.72-2.43-1.57-3.16-1.29-1.11-2.37-.28-1.72.72C255.14,147.17,255,149.22,255.74,150.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "255.927px 147.425px"
    },
    id: "ely57uwghzovl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.85,152c3.63,3.08,4,8.56,4,8.56a7.73,7.73,0,0,0-.39-5.48C268.15,152,265.85,152,265.85,152Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "268.014px 156.28px"
    },
    id: "eliv39lwijvt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.65,145.34c1.17-.16,2.19-.21,1.87-1.72a20.94,20.94,0,0,1-.66-4.58c.1-1-.21-1.95-1.36-1.7s-1.74.4-1.63,1.75a33.74,33.74,0,0,1,.07,4.66C261.82,144.71,262.07,145.57,263.65,145.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "263.718px 141.339px"
    },
    id: "elslrc6ewj3pl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.2,137c-.85.12-1.41.36-1.45-.79s-.16-2.31-.23-3.63.42-1.75.93-1.82,1,.41,1.31,1.57.44,2.52.65,3.39S264.32,136.83,263.2,137Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "262.993px 133.93px"
    },
    id: "elsskq3cyiao",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.42,138.23c.49-.07.83-.11.86-.31s-.2-1.47-1-1.34-.85,1.31-.75,1.54S263.05,138.28,263.42,138.23Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "263.387px 137.426px"
    },
    id: "elkl2krg28mq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.82,145.62c1.18,0,2.2,0,2.05-1.5s-.35-3.49-.38-4.47c0-1.24-.21-2.15-1.39-2s-1.31.25-1.35,1.6a32.88,32.88,0,0,1-.45,4.64C270.07,144.79,270.23,145.67,271.82,145.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "272.05px 141.628px"
    },
    id: "elbdwlzcz89e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.06,137.51c-.86.05-1.43.24-1.38-.91s0-1.86.05-3.17.56-1.72,1.08-1.75.93.49,1.17,1.68.25,2.09.39,3S273.19,137.44,272.06,137.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "272.039px 134.616px"
    },
    id: "elk2bdaen24hn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.18,138.44c.49,0,.83-.05.87-.25s-.1-1.48-1-1.4-.94,1.24-.85,1.48S271.8,138.47,272.18,138.44Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "272.112px 137.625px"
    },
    id: "elm1874w0uiyd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.73,146.62c1.13.11,1.7-.1,1.66-1.13-.09-1.86,0-2.7-.09-3.63-.12-1.61-.29-1.84-1.42-1.77s-1.22.38-1.33,1.73c-.09,1.1-.16,2.26-.21,3.43C274.31,146.17,274.77,146.52,275.73,146.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "275.865px 143.363px"
    },
    id: "elsppze6o2ue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.89,139.51c-.83,0-1.16.15-1.28-.95a7.55,7.55,0,0,1,0-1.76c.17-1.26.63-1.62,1.13-1.61s.87.51,1,1.67a16.17,16.17,0,0,1,.19,1.61C277,139.33,277,139.52,275.89,139.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "275.757px 137.353px"
    },
    id: "elouz26mie6pd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.94,140.56c.47-.05.79-.07.83-.26s-.13-1.42-1-1.32-.87,1.22-.78,1.44S275.57,140.6,275.94,140.56Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "275.863px 139.783px"
    },
    id: "elu5419t5v9jk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.78,145.14c1.17-.08,2.19-.06,2-1.59a32.8,32.8,0,0,1-.43-5.84c.16-1-.08-2-1.25-1.79s-1.76.28-1.74,1.64a54.53,54.53,0,0,1-.16,5.88C266,144.39,266.18,145.26,267.78,145.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "267.968px 140.521px"
    },
    id: "elwmhup0uaa7j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.81,135.64c-.85.17-1.39.44-1.5-.71s-.3-2.29-.44-3.6.31-1.77.81-1.88,1,.35,1.4,1.5.6,2.48.86,3.34S268.91,135.41,267.81,135.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "267.437px 132.614px"
    },
    id: "elcqakzgmbb7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.93,136.8c.5,0,.83,0,.88-.25s-.1-1.47-.95-1.4-.95,1.24-.86,1.48S267.55,136.83,267.93,136.8Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "267.896px 135.985px"
    },
    id: "elzrmd069m9t",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.05,196.58c-1.9,8.65-4.79,10.69-7.82,11-5.17.55-10.38-6.3-7.4-10.77,2.1-3.16,3.08-4.61,3.33-5.51a1.77,1.77,0,0,0-2.69-2,11.8,11.8,0,0,0-2.21,1.88l-1.06-.53,2.22-4.64C254.7,185.86,263.62,188.47,267.05,196.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "258.125px 196.808px"
    },
    id: "elq0qna6tjbb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,190.51a1,1,0,1,0,.95-1.1A1,1,0,0,0,257,190.51Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "257.995px 190.409px"
    },
    id: "elimfaj4t3259",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.88,203.41c-.92-1.17-.39-3.24,1.42-6.12s2.38-4.77,3.86-4.15a5.78,5.78,0,0,1,2.68,7.39C262.22,204.3,259,207.36,255.88,203.41Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "259.866px 199.139px"
    },
    id: "elcjqq0bbuwd7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.33,199.88c-.17,5.44-3.09,7.88-3.09,7.88,0,1.5-.25,10.33-.6,15.78-7.84,10.27-17.14,19-27.1,24.7-9.51,5.49-18.55,7.69-26.26,6.52,1.79-10.37,9.23-20.17,10-25.33,0,0-1.18-5-2.64-11.09l-.12-.5c-1.39-5.84-3-12.6-4.08-17-2.23-9.18-1.22-18.69,1.72-19.77a80.46,80.46,0,0,1,10.54-2.89c2.24-.51,5.32-1.29,14.9-1.54,4.2-.11,7.78.17,7.78.17a92.2,92.2,0,0,1,10.27,7.89C233.56,190.68,235.53,193.68,235.33,199.88Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "206.812px 215.84px"
    },
    id: "els7uwrziwywj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eleobeun2adi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196,210.54a13.38,13.38,0,0,0,13.37,5.72,14.14,14.14,0,0,0,11.16-8.71s.65,9.84-10.92,11.06S196,210.54,196,210.54Z",
    style: {
      opacity: 0.2,
      transformOrigin: "208.268px 213.135px"
    },
    className: "animable",
    id: "el2fwqjziy5ix"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.47,171.32a17.75,17.75,0,0,1-5.84-1.52c-2.22-.88-4-.06-6.3-.2-2.05-.12-3.41-1.56-4.47-3.15-.89-1.31-1.3-3.22-2.8-4-1-.54-2.06-.9-3.09-1.51a6.76,6.76,0,0,1-3.37-6.15,5.26,5.26,0,0,0,3.42-2.26c1.23-1.86.65-4,.87-6a4.07,4.07,0,0,1,2.68-3.16c1.69-.8,3.12-.83,3.89-2.63.69-1.62,1.33-3.36,2.17-4.9,1-1.76,3.31-2.82,5.66-3a8.14,8.14,0,0,1,6.22-8.58,15,15,0,0,1,5.72-.58c1.8.23,3.31-1.13,4.9-1.82,2.49-1.08,5.67-1.43,8,.29,1.36,1,1.73,2.92,3.34,3.7s3.84-.52,5.73-.2c2.6.45,5.57,2.26,6.72,4.65,1.06,2.22.15,4.74,1,6.85.67,1.6,3.68,2.44,4.39.39a3.55,3.55,0,0,1-.25,3.67c-1.18,1.78-3.45,1.89-5.36,2.09a4,4,0,0,1,3.5,2.47,12,12,0,0,1,.68,2.46c.27,1,.55,2.35,1.43,3a2.9,2.9,0,0,0,3,.14c.41,2.86-.33,5.75-3.34,6.63a3.64,3.64,0,0,0-2.5,1.63,11.15,11.15,0,0,1-2.42,3.64,8.82,8.82,0,0,1-4.88,2c-1.47.11-3.12-.29-4.56.06-2.88.69-4.58,3.68-7.62,4-1.63.18-3.24-.44-4.86-.39-.76,0-1.45.31-2.21.3s-1.55-.33-2.35-.39a4.92,4.92,0,0,0-3.1,1.29,5.55,5.55,0,0,1-2.92,1.15A9.92,9.92,0,0,1,195.47,171.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "203.504px 146.139px"
    },
    id: "ell2pcgl7hu7s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.77,133.09s5.07,4.26,6.38,19.29c.85,9.72-1.67,14.65-6,17.22-1.91,1.13-4.32,1.51-7.34,1.68l.68,5.94s11.93,8.3,3.47,10.93c-4.23,1.32-9.79.54-14-1.71s-6.84-7.53-6.84-7.53l-1.67-14.73s-1.89,3.54-6.45.89c-4.33-2.52-5.27-7.78-2.77-10.23,3.68-3.59,7.11-.89,8.41.91s4.51,1.75,2.09-7c2.73-1.26,5.41-6.45,3.16-12.56C202.09,132.91,211,129.31,218.77,133.09Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "204.09px 160.133px"
    },
    id: "elq4bh56ksqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.79,159.85l6.13,1a3.05,3.05,0,0,1-3.5,2.66A3.25,3.25,0,0,1,207.79,159.85Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "210.838px 161.698px"
    },
    id: "elm1nlg2x33i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.12,143.47l-4.1,2.32a2.26,2.26,0,0,1,.8-3.18A2.48,2.48,0,0,1,206.12,143.47Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "203.894px 144.046px"
    },
    id: "el7sog39imau4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.55,142.83,221,144.3a2.26,2.26,0,0,0-1.42-3A2.47,2.47,0,0,0,216.55,142.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "218.857px 142.748px"
    },
    id: "elg3tgi8iucld",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.44,146.41l2.35,10.22,5.31-2.5C216.63,150.71,214.08,147.12,211.44,146.41Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "215.27px 151.52px"
    },
    id: "el2omtx5g5n3l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.81,171.28a29.21,29.21,0,0,1-11.08-1.95c-1.9-.8-4.11-4.38-4.75-5.42,0,0,1.14,5.38,4.5,7.34,4.47,2.6,11.6,2.37,11.6,2.37Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "204.03px 168.768px"
    },
    id: "el3me4oxg35n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.44,148.12a1.86,1.86,0,0,0,1.83,1.8,1.74,1.74,0,0,0,1.78-1.77,1.84,1.84,0,0,0-1.83-1.79A1.73,1.73,0,0,0,217.44,148.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "219.245px 148.14px"
    },
    id: "el7a9i044ld39",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.84,149.36a1.86,1.86,0,0,0,1.84,1.8,1.74,1.74,0,0,0,1.77-1.76,1.85,1.85,0,0,0-1.83-1.8A1.74,1.74,0,0,0,203.84,149.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "205.645px 149.38px"
    },
    id: "elsrwzep8jzbs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,161.56a4.19,4.19,0,0,1,4.19,1.71,2.91,2.91,0,0,1-1.78.25A3.2,3.2,0,0,1,208,161.56Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "210.095px 162.527px"
    },
    id: "elp0kmnka4j1j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.92,136.17c1.9-2.22,9,1.63,13.36,5.09s13.05,6.49,16.7-1.1c-2.15-1.12-4.1-7.29-9.8-10.65S200,127,197.92,136.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "212.95px 136.294px"
    },
    id: "elb7861q4zoyb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.29,179.46c-10.17,2.17-11.54,2.73-15.71,11.24-3.52,7.17-14.05,28.44-16.22,34.15-1.81,4.74-2.4,8.6,8.07,14.25,9.13,4.93,16.09,8,16.09,8,2.28-5.17,4.76-9.65,6.74-14.39l-10.39-6.6s8.37-12.64,11.25-17.6C191.5,202.66,197,188.84,188.29,179.46Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "174.143px 213.28px"
    },
    id: "elpqg8vl3vh2k",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-112",
    className: "animable",
    style: {
      transformOrigin: "401.455px 55.3511px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-112",
    className: "animable",
    style: {
      transformOrigin: "401.455px 55.3511px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-112",
    className: "animable",
    style: {
      transformOrigin: "401.455px 55.3511px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.93,83.54l3-5.66-2.43-7V66.59l7.42,4.29v4.28l-3.19,5.53a.45.45,0,0,1-.22.19h0Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "403.925px 75.065px"
    },
    id: "elv57kxnpd93",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcp440ir8xys"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.93,83.54l3-5.66-2.43-7V66.59l7.42,4.29v4.28l-3.19,5.53a.45.45,0,0,1-.22.19h0Z",
    style: {
      opacity: 0.2,
      transformOrigin: "403.925px 75.065px"
    },
    className: "animable",
    id: "elw3jlnzxb8u8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M382.21,32.54a4.91,4.91,0,0,1,2.23-3.85l1.81-1.05a4.91,4.91,0,0,1,4.45,0l27.77,16.07a4.91,4.91,0,0,1,2.23,3.85V78.12A4.93,4.93,0,0,1,418.47,82l-1.81,1a4.91,4.91,0,0,1-4.45,0l-8.93-5.16-3.18,5.51a.47.47,0,0,1-.86-.08l-3.37-9.71L384.44,67a4.93,4.93,0,0,1-2.23-3.86Z",
    style: {
      fill: "#90CAF9",
      transformOrigin: "401.455px 55.3511px"
    },
    id: "eliysbneswld",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbbonmtpirsm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.7,78.12A4.93,4.93,0,0,1,418.47,82l-1.81,1a5,5,0,0,1-4.07.18c1.05.4,1.85-.19,1.85-1.46V51.18a4.61,4.61,0,0,0-.65-2.2l6.26-3.61a4.57,4.57,0,0,1,.65,2.19Z",
    style: {
      opacity: 0.2,
      transformOrigin: "416.645px 64.4491px"
    },
    className: "animable",
    id: "elxpzsy8ukqg"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elqlp86kbah7g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.29,31.91c.26-.95,1.12-1.25,2.14-.65l27.79,16.06A4.47,4.47,0,0,1,413.78,49L420,45.37a4.49,4.49,0,0,0-1.57-1.66L390.7,27.64a5,5,0,0,0-4.45,0l-1.82,1.05A4.89,4.89,0,0,0,382.29,31.91Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "401.145px 38.0588px"
    },
    className: "animable",
    id: "el8thn4j2q2ml"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Like--inject-112",
    className: "animable",
    style: {
      transformOrigin: "399.21px 56.9696px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.17,65.41a1,1,0,0,1-1.46.92,5.71,5.71,0,0,1,.22,1.5c0,1-.78,1.43-1.92.78l-8.63-5V52.35a34.46,34.46,0,0,0,2.59-3.2,24.89,24.89,0,0,0,0-4c0-.42,1.42.19,2.32,1.67a5.26,5.26,0,0,1,.51,1.15,13.93,13.93,0,0,1,.51,2.39,7.83,7.83,0,0,1-.17,3l5.22,3a2.82,2.82,0,0,1,1,1,3.74,3.74,0,0,1,.55,1.76c0,1-.56,1.25-.85,1.28a3.22,3.22,0,0,1,1,2.28c0,.79-.48,1.36-1.27,1.09A3.89,3.89,0,0,1,407.17,65.41Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "401.72px 56.9696px"
    },
    id: "elods74q8ofwm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.36,49.63l0,12.17a.93.93,0,0,0,.42.73l2.91,1.68c.24.14.42,0,.42-.24V51.82a.9.9,0,0,0-.42-.73l-2.92-1.71C390.55,49.25,390.36,49.35,390.36,49.63Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "392.235px 56.7947px"
    },
    id: "ele9gi88060ou",
    className: "animable"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocProfile);
export default __webpack_public_path__ + "static/media/docProfile.a7abe097e967275f79a40c27dd646572.svg";
export { ForwardRef as ReactComponent };